// Generated by npm run icons:build. Do not edit manually.
export type GeneratedIconSourceSize = 12 | 16 | 24 | 32 | 48 | 64

export type GeneratedIconName =
  | 'arrows/arrow-bottom-left'
  | 'arrows/arrow-bottom-right'
  | 'arrows/arrow-down'
  | 'arrows/arrow-down-2'
  | 'arrows/arrow-down-3'
  | 'arrows/arrow-e'
  | 'arrows/arrow-left'
  | 'arrows/arrow-left-2'
  | 'arrows/arrow-left-3'
  | 'arrows/arrow-n'
  | 'arrows/arrow-right'
  | 'arrows/arrow-right-2'
  | 'arrows/arrow-right-3'
  | 'arrows/arrow-s'
  | 'arrows/arrow-tool'
  | 'arrows/arrow-top-left'
  | 'arrows/arrow-top-right'
  | 'arrows/arrow-up'
  | 'arrows/arrow-up-2'
  | 'arrows/arrow-up-3'
  | 'arrows/arrow-w'
  | 'arrows/backward'
  | 'arrows/block-down'
  | 'arrows/block-left'
  | 'arrows/block-right'
  | 'arrows/block-up'
  | 'arrows/box-arrow-bottom-left'
  | 'arrows/box-arrow-bottom-right'
  | 'arrows/box-arrow-top-left'
  | 'arrows/box-arrow-top-right'
  | 'arrows/box-caret-down'
  | 'arrows/box-caret-left'
  | 'arrows/box-caret-right'
  | 'arrows/box-caret-up'
  | 'arrows/box-ctrl-down'
  | 'arrows/box-ctrl-left'
  | 'arrows/box-ctrl-right'
  | 'arrows/box-ctrl-up'
  | 'arrows/circle-caret-down'
  | 'arrows/circle-caret-left'
  | 'arrows/circle-caret-right'
  | 'arrows/circle-caret-up'
  | 'arrows/circle-ctrl-down'
  | 'arrows/circle-ctrl-left'
  | 'arrows/circle-ctrl-right'
  | 'arrows/circle-ctrl-up'
  | 'arrows/conversion'
  | 'arrows/corner-bottom-left'
  | 'arrows/corner-bottom-right'
  | 'arrows/corner-top-left'
  | 'arrows/corner-top-right'
  | 'arrows/ctrl-backward'
  | 'arrows/ctrl-down'
  | 'arrows/ctrl-forward'
  | 'arrows/ctrl-left'
  | 'arrows/ctrl-right'
  | 'arrows/ctrl-up'
  | 'arrows/curved-arrow-down'
  | 'arrows/curved-arrow-left'
  | 'arrows/curved-arrow-right'
  | 'arrows/cycle'
  | 'arrows/data-download'
  | 'arrows/data-upload'
  | 'arrows/delete-key'
  | 'arrows/direction-down'
  | 'arrows/direction-left'
  | 'arrows/direction-right'
  | 'arrows/direction-up'
  | 'arrows/double-arrow-left'
  | 'arrows/double-arrow-right'
  | 'arrows/down-arrow'
  | 'arrows/download'
  | 'arrows/download-data'
  | 'arrows/download-file'
  | 'arrows/eject'
  | 'arrows/enlarge'
  | 'arrows/enlarge-h'
  | 'arrows/enter'
  | 'arrows/expand'
  | 'arrows/expand-2'
  | 'arrows/expand-h'
  | 'arrows/expand-window'
  | 'arrows/export'
  | 'arrows/file-download'
  | 'arrows/file-upload'
  | 'arrows/format-left'
  | 'arrows/format-right'
  | 'arrows/forward'
  | 'arrows/fullscreen'
  | 'arrows/increase'
  | 'arrows/input'
  | 'arrows/launch'
  | 'arrows/launch-app'
  | 'arrows/left-arrow'
  | 'arrows/log-in'
  | 'arrows/log-out'
  | 'arrows/logout'
  | 'arrows/maximize-area'
  | 'arrows/move-down'
  | 'arrows/move-layer-down'
  | 'arrows/move-layer-left'
  | 'arrows/move-layer-right'
  | 'arrows/move-layer-up'
  | 'arrows/move-left'
  | 'arrows/move-right'
  | 'arrows/move-up'
  | 'arrows/nav-down'
  | 'arrows/nav-left'
  | 'arrows/nav-right'
  | 'arrows/nav-up'
  | 'arrows/open-in-browser'
  | 'arrows/pointing-down'
  | 'arrows/pointing-left'
  | 'arrows/pointing-right'
  | 'arrows/pointing-up'
  | 'arrows/refresh'
  | 'arrows/reload'
  | 'arrows/reply'
  | 'arrows/reply-arrow'
  | 'arrows/resize-x'
  | 'arrows/resize-y'
  | 'arrows/respond-arrow'
  | 'arrows/right-arrow'
  | 'arrows/share'
  | 'arrows/sharing'
  | 'arrows/sign-down'
  | 'arrows/sign-left'
  | 'arrows/sign-right'
  | 'arrows/sign-up'
  | 'arrows/slide-left'
  | 'arrows/slide-right'
  | 'arrows/social-sharing'
  | 'arrows/swap-horizontal'
  | 'arrows/swap-vertical'
  | 'arrows/system-update'
  | 'arrows/traffic'
  | 'arrows/transaction'
  | 'arrows/triangle-down'
  | 'arrows/triangle-left'
  | 'arrows/triangle-line-down'
  | 'arrows/triangle-line-left'
  | 'arrows/triangle-line-right'
  | 'arrows/triangle-line-up'
  | 'arrows/triangle-right'
  | 'arrows/triangle-up'
  | 'arrows/turn-e'
  | 'arrows/turn-n'
  | 'arrows/turn-s'
  | 'arrows/turn-w'
  | 'arrows/up-arrow'
  | 'arrows/upload'
  | 'arrows/upload-data'
  | 'arrows/upload-file'
  | 'business-finance/address-book'
  | 'business-finance/agenda'
  | 'business-finance/algorithm'
  | 'business-finance/app-services'
  | 'business-finance/archery-target'
  | 'business-finance/atm'
  | 'business-finance/award-49'
  | 'business-finance/badge'
  | 'business-finance/bank-statement'
  | 'business-finance/bill'
  | 'business-finance/bitcoin'
  | 'business-finance/block'
  | 'business-finance/blockchain'
  | 'business-finance/board-27'
  | 'business-finance/board-28'
  | 'business-finance/board-29'
  | 'business-finance/board-30'
  | 'business-finance/books'
  | 'business-finance/briefcase-24'
  | 'business-finance/briefcase-25'
  | 'business-finance/briefcase-26'
  | 'business-finance/bulb-61'
  | 'business-finance/bulb-62'
  | 'business-finance/bulb-63'
  | 'business-finance/business-agent'
  | 'business-finance/business-contact-85'
  | 'business-finance/business-contact-86'
  | 'business-finance/business-contact-87'
  | 'business-finance/business-contact-88'
  | 'business-finance/businessman-03'
  | 'business-finance/businessman-04'
  | 'business-finance/calculator'
  | 'business-finance/candlestick-chart'
  | 'business-finance/card-edit'
  | 'business-finance/card-favorite'
  | 'business-finance/card-remove'
  | 'business-finance/card-update'
  | 'business-finance/certificate'
  | 'business-finance/cloud-mining'
  | 'business-finance/cockade'
  | 'business-finance/coins'
  | 'business-finance/conference-room'
  | 'business-finance/connect'
  | 'business-finance/contactless-card'
  | 'business-finance/contacts'
  | 'business-finance/copyright'
  | 'business-finance/credit-card'
  | 'business-finance/credit-card-in'
  | 'business-finance/credit-locked'
  | 'business-finance/crypto-wallet'
  | 'business-finance/currency-dollar'
  | 'business-finance/currency-euro'
  | 'business-finance/currency-exchange'
  | 'business-finance/currency-exchange-2'
  | 'business-finance/currency-pound'
  | 'business-finance/currency-yen'
  | 'business-finance/debt'
  | 'business-finance/decentralize'
  | 'business-finance/decision-process'
  | 'business-finance/dice'
  | 'business-finance/factory'
  | 'business-finance/globe'
  | 'business-finance/goal-65'
  | 'business-finance/gold'
  | 'business-finance/hammer'
  | 'business-finance/hand-card'
  | 'business-finance/handout'
  | 'business-finance/handshake'
  | 'business-finance/hat'
  | 'business-finance/hierarchy-53'
  | 'business-finance/hierarchy-54'
  | 'business-finance/hierarchy-55'
  | 'business-finance/hierarchy-56'
  | 'business-finance/chart'
  | 'business-finance/chart-bar-32'
  | 'business-finance/chart-bar-33'
  | 'business-finance/chart-growth'
  | 'business-finance/chart-pie-35'
  | 'business-finance/chart-pie-36'
  | 'business-finance/cheque'
  | 'business-finance/chess-knight'
  | 'business-finance/chess-tower'
  | 'business-finance/info-point'
  | 'business-finance/interview'
  | 'business-finance/joint-account'
  | 'business-finance/laptop-71'
  | 'business-finance/laptop-72'
  | 'business-finance/laptop-91'
  | 'business-finance/law'
  | 'business-finance/line-chart'
  | 'business-finance/loan'
  | 'business-finance/logic'
  | 'business-finance/math'
  | 'business-finance/miner'
  | 'business-finance/mobile-banking'
  | 'business-finance/mobile-card'
  | 'business-finance/money-11'
  | 'business-finance/money-12'
  | 'business-finance/money-13'
  | 'business-finance/money-bag'
  | 'business-finance/money-coins'
  | 'business-finance/money-growth'
  | 'business-finance/money-time'
  | 'business-finance/money-transfer'
  | 'business-finance/mortgage'
  | 'business-finance/name-card'
  | 'business-finance/negative-judgement'
  | 'business-finance/net'
  | 'business-finance/new-construction'
  | 'business-finance/nodes'
  | 'business-finance/notes'
  | 'business-finance/office'
  | 'business-finance/office-badge'
  | 'business-finance/office-chair'
  | 'business-finance/office-pass'
  | 'business-finance/online-banking'
  | 'business-finance/payee'
  | 'business-finance/payment'
  | 'business-finance/payment-method'
  | 'business-finance/payor'
  | 'business-finance/percentage-38'
  | 'business-finance/percentage-39'
  | 'business-finance/personal-trainer'
  | 'business-finance/pig'
  | 'business-finance/pin'
  | 'business-finance/plug'
  | 'business-finance/pos'
  | 'business-finance/positive-judgement'
  | 'business-finance/presentation'
  | 'business-finance/privacy-policy'
  | 'business-finance/progress'
  | 'business-finance/puzzle-09'
  | 'business-finance/puzzle-10'
  | 'business-finance/ranking'
  | 'business-finance/rate-down'
  | 'business-finance/rate-up'
  | 'business-finance/refund'
  | 'business-finance/round-dollar'
  | 'business-finance/round-euro'
  | 'business-finance/round-pound'
  | 'business-finance/round-yen'
  | 'business-finance/safe'
  | 'business-finance/savings'
  | 'business-finance/scale'
  | 'business-finance/sign'
  | 'business-finance/signature'
  | 'business-finance/statistics'
  | 'business-finance/stock-market'
  | 'business-finance/tactic'
  | 'business-finance/temple'
  | 'business-finance/tie-01'
  | 'business-finance/tie-02'
  | 'business-finance/transaction'
  | 'business-finance/transactions'
  | 'business-finance/wallet-43'
  | 'business-finance/wallet-44'
  | 'business-finance/wallet-90'
  | 'desing-development/3d-29'
  | 'desing-development/3d-model'
  | 'desing-development/ai-generated-img'
  | 'desing-development/album'
  | 'desing-development/align-bottom'
  | 'desing-development/align-center-horizontal'
  | 'desing-development/align-center-vertical'
  | 'desing-development/align-left'
  | 'desing-development/align-right'
  | 'desing-development/align-top'
  | 'desing-development/android'
  | 'desing-development/angle'
  | 'desing-development/animation-14'
  | 'desing-development/animation-31'
  | 'desing-development/animation-32'
  | 'desing-development/api'
  | 'desing-development/app'
  | 'desing-development/app-store'
  | 'desing-development/apple'
  | 'desing-development/apps'
  | 'desing-development/arrow-tool'
  | 'desing-development/artboard'
  | 'desing-development/binary-code'
  | 'desing-development/blend'
  | 'desing-development/block'
  | 'desing-development/blockchain'
  | 'desing-development/board-2'
  | 'desing-development/book-bookmark'
  | 'desing-development/book-bookmark-2'
  | 'desing-development/book-open'
  | 'desing-development/book-open-2'
  | 'desing-development/border'
  | 'desing-development/border-radius'
  | 'desing-development/border-width'
  | 'desing-development/browser-edge'
  | 'desing-development/browser-edge-legacy'
  | 'desing-development/browser-firefox'
  | 'desing-development/browser-chrome'
  | 'desing-development/browser-ie'
  | 'desing-development/browser-opera'
  | 'desing-development/browser-safari'
  | 'desing-development/brush'
  | 'desing-development/bucket'
  | 'desing-development/bullet-list-67'
  | 'desing-development/bullet-list-68'
  | 'desing-development/bullet-list-69'
  | 'desing-development/bullet-list-70'
  | 'desing-development/button-2'
  | 'desing-development/canvas'
  | 'desing-development/cards'
  | 'desing-development/clone'
  | 'desing-development/code'
  | 'desing-development/code-editor'
  | 'desing-development/collection'
  | 'desing-development/command'
  | 'desing-development/compare-items'
  | 'desing-development/compass'
  | 'desing-development/components'
  | 'desing-development/contrast-2'
  | 'desing-development/copy'
  | 'desing-development/creative-commons'
  | 'desing-development/crop'
  | 'desing-development/css3'
  | 'desing-development/cursor-48'
  | 'desing-development/cursor-49'
  | 'desing-development/cursor-add'
  | 'desing-development/cursor-grab'
  | 'desing-development/cursor-load'
  | 'desing-development/cursor-menu'
  | 'desing-development/cursor-not-allowed'
  | 'desing-development/cursor-pointer'
  | 'desing-development/cursor-text'
  | 'desing-development/data-table'
  | 'desing-development/decision-process'
  | 'desing-development/depth'
  | 'desing-development/design'
  | 'desing-development/design-dev'
  | 'desing-development/design-system'
  | 'desing-development/digital-image'
  | 'desing-development/distribute-horizontal'
  | 'desing-development/distribute-vertical'
  | 'desing-development/divider'
  | 'desing-development/drag'
  | 'desing-development/drop-15'
  | 'desing-development/duplicate'
  | 'desing-development/edit-curves'
  | 'desing-development/edit-levels'
  | 'desing-development/empty'
  | 'desing-development/eraser-32'
  | 'desing-development/filter-organization'
  | 'desing-development/flip-horizontal'
  | 'desing-development/flip-vertical'
  | 'desing-development/floors'
  | 'desing-development/form'
  | 'desing-development/frame'
  | 'desing-development/function'
  | 'desing-development/geometry'
  | 'desing-development/git-commit'
  | 'desing-development/gradient'
  | 'desing-development/grain-effect'
  | 'desing-development/graphics-tablet'
  | 'desing-development/grid-system'
  | 'desing-development/group'
  | 'desing-development/hash-mark'
  | 'desing-development/height-2'
  | 'desing-development/hot-key'
  | 'desing-development/html5'
  | 'desing-development/image'
  | 'desing-development/image-2'
  | 'desing-development/img-stack'
  | 'desing-development/invert-process'
  | 'desing-development/js-console'
  | 'desing-development/json-logo'
  | 'desing-development/ladybug'
  | 'desing-development/layers'
  | 'desing-development/layers-2'
  | 'desing-development/layout'
  | 'desing-development/layout-11'
  | 'desing-development/layout-25'
  | 'desing-development/layout-grid'
  | 'desing-development/license-key'
  | 'desing-development/magic-wand'
  | 'desing-development/magnet'
  | 'desing-development/markdown'
  | 'desing-development/marker'
  | 'desing-development/mask-oval'
  | 'desing-development/mask-rect'
  | 'desing-development/measure-02'
  | 'desing-development/measure-17'
  | 'desing-development/measure-big'
  | 'desing-development/microsoft'
  | 'desing-development/mirror-display'
  | 'desing-development/mirror-tablet-phone'
  | 'desing-development/mobile-design'
  | 'desing-development/mobile-dev'
  | 'desing-development/mobile-phone'
  | 'desing-development/mouse'
  | 'desing-development/mouse-2'
  | 'desing-development/move'
  | 'desing-development/move-down-2'
  | 'desing-development/move-up-2'
  | 'desing-development/newsletter-dev'
  | 'desing-development/note'
  | 'desing-development/note-code'
  | 'desing-development/octagon'
  | 'desing-development/octagon-m'
  | 'desing-development/paint-16'
  | 'desing-development/paint-37'
  | 'desing-development/paint-38'
  | 'desing-development/paint-brush'
  | 'desing-development/paint-bucket-39'
  | 'desing-development/paint-bucket-40'
  | 'desing-development/palette'
  | 'desing-development/pantone'
  | 'desing-development/paper-design'
  | 'desing-development/paper-dev'
  | 'desing-development/paragraph-2'
  | 'desing-development/path-exclude'
  | 'desing-development/path-intersect'
  | 'desing-development/path-minus'
  | 'desing-development/path-unite'
  | 'desing-development/patch-19'
  | 'desing-development/patch-34'
  | 'desing-development/pc-mouse'
  | 'desing-development/pen-01'
  | 'desing-development/pen-23'
  | 'desing-development/pen-tool'
  | 'desing-development/photo-album'
  | 'desing-development/photo-editor'
  | 'desing-development/pilcrow'
  | 'desing-development/plug-2'
  | 'desing-development/position'
  | 'desing-development/priority-high'
  | 'desing-development/priority-highest'
  | 'desing-development/priority-low'
  | 'desing-development/priority-lowest'
  | 'desing-development/priority-normal'
  | 'desing-development/prototype'
  | 'desing-development/refresh-02'
  | 'desing-development/responsive'
  | 'desing-development/roadmap'
  | 'desing-development/row-table'
  | 'desing-development/ruler-pencil'
  | 'desing-development/scale-2'
  | 'desing-development/scale-down'
  | 'desing-development/scale-up'
  | 'desing-development/scissors'
  | 'desing-development/scissors-dashed'
  | 'desing-development/selection'
  | 'desing-development/shape-adjust'
  | 'desing-development/shape-arrow'
  | 'desing-development/shape-circle'
  | 'desing-development/shape-custom'
  | 'desing-development/shape-line'
  | 'desing-development/shape-oval'
  | 'desing-development/shape-polygon'
  | 'desing-development/shape-polygon-2'
  | 'desing-development/shape-rectangle'
  | 'desing-development/shape-square'
  | 'desing-development/shape-star'
  | 'desing-development/shape-triangle'
  | 'desing-development/shape-triangle-2'
  | 'desing-development/shapes'
  | 'desing-development/sharpener'
  | 'desing-development/sidebar'
  | 'desing-development/size-large'
  | 'desing-development/size-medium'
  | 'desing-development/size-small'
  | 'desing-development/slice'
  | 'desing-development/slider'
  | 'desing-development/space-divider'
  | 'desing-development/sparks'
  | 'desing-development/spray-can'
  | 'desing-development/stack'
  | 'desing-development/stamp'
  | 'desing-development/style'
  | 'desing-development/tablet-mobile'
  | 'desing-development/texture'
  | 'desing-development/three-dimensional-object'
  | 'desing-development/time-machine'
  | 'desing-development/timeline'
  | 'desing-development/todo'
  | 'desing-development/tool-blur'
  | 'desing-development/tool-hand'
  | 'desing-development/tool-select'
  | 'desing-development/transactions'
  | 'desing-development/transform'
  | 'desing-development/transform-2d'
  | 'desing-development/transform-origin'
  | 'desing-development/transparent'
  | 'desing-development/type-tool'
  | 'desing-development/typography'
  | 'desing-development/ungroup'
  | 'desing-development/usb'
  | 'desing-development/vector'
  | 'desing-development/vibrance'
  | 'desing-development/wand'
  | 'desing-development/watch-dev'
  | 'desing-development/web-design'
  | 'desing-development/webpage'
  | 'desing-development/width'
  | 'desing-development/window-code'
  | 'desing-development/window-dev'
  | 'desing-development/window-paragraph'
  | 'desing-development/window-responsive'
  | 'desing-development/wireframe'
  | 'desing-development/zoom'
  | 'education/abc'
  | 'education/agenda'
  | 'education/agenda-bookmark'
  | 'education/album'
  | 'education/astronomy'
  | 'education/atom'
  | 'education/award-49'
  | 'education/backpack-57'
  | 'education/backpack-58'
  | 'education/basketball'
  | 'education/biochemistry'
  | 'education/biology'
  | 'education/board-27'
  | 'education/board-51'
  | 'education/book'
  | 'education/book-39'
  | 'education/book-bookmark'
  | 'education/book-bookmark-2'
  | 'education/book-open'
  | 'education/book-open-2'
  | 'education/bookmark'
  | 'education/books'
  | 'education/books-46'
  | 'education/botany'
  | 'education/brush'
  | 'education/bus'
  | 'education/bus-front-12'
  | 'education/buzz'
  | 'education/calculator'
  | 'education/certificate'
  | 'education/cockade'
  | 'education/collection'
  | 'education/compass'
  | 'education/design'
  | 'education/earth-science'
  | 'education/ecology'
  | 'education/equation'
  | 'education/eraser-32'
  | 'education/eraser-33'
  | 'education/flask'
  | 'education/function'
  | 'education/geometry'
  | 'education/glasses'
  | 'education/glasses-2'
  | 'education/globe'
  | 'education/globe-2'
  | 'education/grammar-check'
  | 'education/hat-3'
  | 'education/chalkboard'
  | 'education/chemistry'
  | 'education/language'
  | 'education/logic'
  | 'education/marker'
  | 'education/math'
  | 'education/measure-02'
  | 'education/measure-17'
  | 'education/measure-big'
  | 'education/medal'
  | 'education/medicine'
  | 'education/microbiology'
  | 'education/microscope'
  | 'education/molecule'
  | 'education/notepad'
  | 'education/notes'
  | 'education/notification'
  | 'education/open-book'
  | 'education/paper'
  | 'education/paper-diploma'
  | 'education/paw'
  | 'education/pc-play-media'
  | 'education/pen-01'
  | 'education/pen-23'
  | 'education/pen-tool'
  | 'education/pencil'
  | 'education/pencil-47'
  | 'education/pendulum'
  | 'education/planet'
  | 'education/potion'
  | 'education/presentation'
  | 'education/rat'
  | 'education/read'
  | 'education/reading'
  | 'education/research'
  | 'education/saved-items'
  | 'education/school'
  | 'education/soccer-ball'
  | 'education/statistics'
  | 'education/survey'
  | 'education/telescope'
  | 'education/translation'
  | 'education/typography'
  | 'emoji/alien-29'
  | 'emoji/angry-10'
  | 'emoji/angry-44'
  | 'emoji/big-eyes'
  | 'emoji/big-smile'
  | 'emoji/bigmouth'
  | 'emoji/bleah'
  | 'emoji/bomb'
  | 'emoji/bored'
  | 'emoji/broken-heart'
  | 'emoji/bug'
  | 'emoji/cake'
  | 'emoji/cry-15'
  | 'emoji/cry-57'
  | 'emoji/cute'
  | 'emoji/devil'
  | 'emoji/disgusted'
  | 'emoji/dizzy-face'
  | 'emoji/fairy-wand'
  | 'emoji/finger-snap'
  | 'emoji/fist'
  | 'emoji/ghost'
  | 'emoji/happy-sun'
  | 'emoji/heart'
  | 'emoji/child'
  | 'emoji/kid'
  | 'emoji/kiss'
  | 'emoji/laugh-17'
  | 'emoji/laugh-35'
  | 'emoji/lips'
  | 'emoji/mad-12'
  | 'emoji/mad-58'
  | 'emoji/malicious'
  | 'emoji/manga-62'
  | 'emoji/manga-63'
  | 'emoji/mask-face'
  | 'emoji/monster'
  | 'emoji/nerd'
  | 'emoji/ninja'
  | 'emoji/no-words'
  | 'emoji/parrot'
  | 'emoji/party'
  | 'emoji/penguin'
  | 'emoji/pirate'
  | 'emoji/poop'
  | 'emoji/puzzled'
  | 'emoji/quite-happy'
  | 'emoji/robot'
  | 'emoji/rock'
  | 'emoji/sad'
  | 'emoji/satisfied'
  | 'emoji/shark'
  | 'emoji/shy'
  | 'emoji/sick'
  | 'emoji/silly'
  | 'emoji/skull'
  | 'emoji/sleep'
  | 'emoji/sleep-2'
  | 'emoji/sloth'
  | 'emoji/smart'
  | 'emoji/smile'
  | 'emoji/smiling-face-glasses'
  | 'emoji/smiling-face-sunglasses'
  | 'emoji/soldier'
  | 'emoji/speechless'
  | 'emoji/spiteful'
  | 'emoji/sunglasses-48'
  | 'emoji/surprise'
  | 'emoji/thumb-down'
  | 'emoji/thumb-up'
  | 'emoji/upset-13'
  | 'emoji/upset-14'
  | 'emoji/what'
  | 'emoji/whiskers'
  | 'emoji/wink-06'
  | 'emoji/wink-11'
  | 'emoji/wink-69'
  | 'energy/battery'
  | 'energy/battery-charging'
  | 'energy/battery-level'
  | 'energy/battery-low'
  | 'energy/battery-power'
  | 'energy/battery-status'
  | 'energy/botany'
  | 'energy/bulb'
  | 'energy/bulb-saver'
  | 'energy/car'
  | 'energy/clover'
  | 'energy/drop'
  | 'energy/eco-home'
  | 'energy/ecology'
  | 'energy/factory'
  | 'energy/forest'
  | 'energy/fuel'
  | 'energy/fuel-2'
  | 'energy/fuel-electric'
  | 'energy/globe'
  | 'energy/humidity-52'
  | 'energy/hybrid-car'
  | 'energy/leaf'
  | 'energy/light-switch'
  | 'energy/money-growth'
  | 'energy/oil'
  | 'energy/panel'
  | 'energy/plant-leaf'
  | 'energy/plant-soil'
  | 'energy/plant-vase'
  | 'energy/plug'
  | 'energy/plug-2'
  | 'energy/power-level'
  | 'energy/progress'
  | 'energy/radiation'
  | 'energy/recycling'
  | 'energy/refresh'
  | 'energy/reload'
  | 'energy/save-planet'
  | 'energy/shower'
  | 'energy/sink-faucet'
  | 'energy/sun'
  | 'energy/temperature'
  | 'energy/temperature-2'
  | 'energy/tree-01'
  | 'energy/waste'
  | 'energy/waste-danger'
  | 'energy/waste-recycling'
  | 'energy/water'
  | 'energy/water-hand'
  | 'energy/water-sink'
  | 'energy/wind'
  | 'energy/windmill'
  | 'energy/windmill-2'
  | 'energy/world'
  | 'files-folders/backup'
  | 'files-folders/browse'
  | 'files-folders/clear-data'
  | 'files-folders/compressed-file'
  | 'files-folders/document'
  | 'files-folders/document-2'
  | 'files-folders/document-copy'
  | 'files-folders/file'
  | 'files-folders/file-2'
  | 'files-folders/file-add'
  | 'files-folders/file-article'
  | 'files-folders/file-audio'
  | 'files-folders/file-copies'
  | 'files-folders/file-copy'
  | 'files-folders/file-delete'
  | 'files-folders/file-export'
  | 'files-folders/file-favorite'
  | 'files-folders/file-font'
  | 'files-folders/file-gallery'
  | 'files-folders/file-gif'
  | 'files-folders/file-gpx'
  | 'files-folders/file-gzip'
  | 'files-folders/file-history'
  | 'files-folders/file-html'
  | 'files-folders/file-ics'
  | 'files-folders/file-image'
  | 'files-folders/file-info'
  | 'files-folders/file-iso'
  | 'files-folders/file-jar'
  | 'files-folders/file-java'
  | 'files-folders/file-jpg'
  | 'files-folders/file-js'
  | 'files-folders/file-json'
  | 'files-folders/file-jsp'
  | 'files-folders/file-link'
  | 'files-folders/file-locked'
  | 'files-folders/file-log'
  | 'files-folders/file-max'
  | 'files-folders/file-md'
  | 'files-folders/file-mkv'
  | 'files-folders/file-money'
  | 'files-folders/file-mov'
  | 'files-folders/file-mp3'
  | 'files-folders/file-mp4'
  | 'files-folders/file-mpg'
  | 'files-folders/file-no-access'
  | 'files-folders/file-obj'
  | 'files-folders/file-otf'
  | 'files-folders/file-pdf'
  | 'files-folders/file-php'
  | 'files-folders/file-play'
  | 'files-folders/file-png'
  | 'files-folders/file-pptx'
  | 'files-folders/file-preferences'
  | 'files-folders/file-psd'
  | 'files-folders/file-py'
  | 'files-folders/file-question'
  | 'files-folders/file-rar'
  | 'files-folders/file-raw'
  | 'files-folders/file-remove'
  | 'files-folders/file-replace'
  | 'files-folders/file-rss'
  | 'files-folders/file-rtf'
  | 'files-folders/file-ruby'
  | 'files-folders/file-search'
  | 'files-folders/file-settings'
  | 'files-folders/file-shared'
  | 'files-folders/file-sketch'
  | 'files-folders/file-sql'
  | 'files-folders/file-srt'
  | 'files-folders/file-starred'
  | 'files-folders/file-svg'
  | 'files-folders/file-sync'
  | 'files-folders/file-text'
  | 'files-folders/file-tif'
  | 'files-folders/file-tiff'
  | 'files-folders/file-ttf'
  | 'files-folders/file-txt'
  | 'files-folders/file-user'
  | 'files-folders/file-vector'
  | 'files-folders/file-vvt'
  | 'files-folders/file-wav'
  | 'files-folders/file-xlsx'
  | 'files-folders/file-xml'
  | 'files-folders/file-zip'
  | 'files-folders/folder-replace'
  | 'files-folders/folder-upload'
  | 'files-folders/folder-user'
  | 'files-folders/folder-vector'
  | 'files-folders/layers'
  | 'files-folders/news'
  | 'files-folders/note'
  | 'files-folders/notebook'
  | 'files-folders/paper'
  | 'files-folders/raw-image'
  | 'files-folders/research'
  | 'files-folders/save-for-later'
  | 'files-folders/saved-items'
  | 'files-folders/upload-file'
  | 'files-folders/zipped-file'
  | 'multimedia/3d-glasses'
  | 'multimedia/adult-content'
  | 'multimedia/ai-generated-img'
  | 'multimedia/album'
  | 'multimedia/alpha-order'
  | 'multimedia/antenna'
  | 'multimedia/anti-shake'
  | 'multimedia/aperture'
  | 'multimedia/audio-description'
  | 'multimedia/audio-jack'
  | 'multimedia/audio-mixer'
  | 'multimedia/auto-flash'
  | 'multimedia/auto-flash-2'
  | 'multimedia/auto-focus'
  | 'multimedia/brightness'
  | 'multimedia/browse'
  | 'multimedia/btn-play'
  | 'multimedia/btn-play-1'
  | 'multimedia/btn-stop'
  | 'multimedia/button-eject'
  | 'multimedia/button-next'
  | 'multimedia/button-pause'
  | 'multimedia/button-play'
  | 'multimedia/button-power'
  | 'multimedia/button-previous'
  | 'multimedia/button-record'
  | 'multimedia/button-rewind'
  | 'multimedia/button-skip'
  | 'multimedia/button-stop'
  | 'multimedia/camcorder'
  | 'multimedia/camera'
  | 'multimedia/camera-2'
  | 'multimedia/camera-3'
  | 'multimedia/camera-flash'
  | 'multimedia/camera-flashlight'
  | 'multimedia/camera-focus'
  | 'multimedia/camera-focus-2'
  | 'multimedia/camera-lens'
  | 'multimedia/camera-roll'
  | 'multimedia/camera-screen'
  | 'multimedia/camera-shooting'
  | 'multimedia/camera-timer'
  | 'multimedia/clapperboard'
  | 'multimedia/clapperboard-2'
  | 'multimedia/clarinet'
  | 'multimedia/compact-camera'
  | 'multimedia/countdown'
  | 'multimedia/countdown-2'
  | 'multimedia/crop'
  | 'multimedia/cycle'
  | 'multimedia/digital-image'
  | 'multimedia/digital-piano'
  | 'multimedia/drums'
  | 'multimedia/earbuds'
  | 'multimedia/edit-color'
  | 'multimedia/edit-contrast'
  | 'multimedia/edit-curves'
  | 'multimedia/edit-levels'
  | 'multimedia/edit-saturation'
  | 'multimedia/event-ticket'
  | 'multimedia/expand'
  | 'multimedia/face-recognition'
  | 'multimedia/file-aac'
  | 'multimedia/file-audio'
  | 'multimedia/file-avi'
  | 'multimedia/file-bmp'
  | 'multimedia/file-epub'
  | 'multimedia/file-flash'
  | 'multimedia/file-flv'
  | 'multimedia/file-mkv'
  | 'multimedia/file-mov'
  | 'multimedia/file-mp3'
  | 'multimedia/file-mp4'
  | 'multimedia/file-mpg'
  | 'multimedia/file-vvt'
  | 'multimedia/file-wav'
  | 'multimedia/film'
  | 'multimedia/flash-off'
  | 'multimedia/flash-off-2'
  | 'multimedia/folder-image'
  | 'multimedia/folder-music'
  | 'multimedia/frame-effect'
  | 'multimedia/full-screen'
  | 'multimedia/fullscreen'
  | 'multimedia/grain-effect'
  | 'multimedia/grid'
  | 'multimedia/guitar'
  | 'multimedia/headphones'
  | 'multimedia/headphones-2'
  | 'multimedia/headphones-3'
  | 'multimedia/headphones-mic'
  | 'multimedia/image'
  | 'multimedia/image-add'
  | 'multimedia/image-delete'
  | 'multimedia/image-location'
  | 'multimedia/img'
  | 'multimedia/img-rotate-left'
  | 'multimedia/img-rotate-right'
  | 'multimedia/img-stack'
  | 'multimedia/instant-camera'
  | 'multimedia/instant-camera-2'
  | 'multimedia/interview'
  | 'multimedia/kid-2'
  | 'multimedia/knob'
  | 'multimedia/layers-2'
  | 'multimedia/lightning'
  | 'multimedia/loudspeaker'
  | 'multimedia/love-movie'
  | 'multimedia/macro'
  | 'multimedia/media-player'
  | 'multimedia/media-stream'
  | 'multimedia/mic'
  | 'multimedia/mic-2'
  | 'multimedia/microphone'
  | 'multimedia/microphone-2'
  | 'multimedia/microphone-off'
  | 'multimedia/movie'
  | 'multimedia/movie-2'
  | 'multimedia/movie-3'
  | 'multimedia/movie-reel'
  | 'multimedia/music'
  | 'multimedia/music-album'
  | 'multimedia/music-cloud'
  | 'multimedia/music-note'
  | 'multimedia/music-playlist'
  | 'multimedia/night'
  | 'multimedia/no-photo'
  | 'multimedia/offline'
  | 'multimedia/options'
  | 'multimedia/pc-play-media'
  | 'multimedia/phone-camera-back'
  | 'multimedia/phone-music'
  | 'multimedia/photo'
  | 'multimedia/photo-album'
  | 'multimedia/photo-frame'
  | 'multimedia/photo-not-allowed'
  | 'multimedia/piano'
  | 'multimedia/piano-2'
  | 'multimedia/picture'
  | 'multimedia/play-media'
  | 'multimedia/play-movie'
  | 'multimedia/player'
  | 'multimedia/playlist'
  | 'multimedia/podcast'
  | 'multimedia/podcast-mic'
  | 'multimedia/polaroid'
  | 'multimedia/polaroid-photo'
  | 'multimedia/polaroid-portrait'
  | 'multimedia/polaroid-shot-delete'
  | 'multimedia/polaroid-shot-new'
  | 'multimedia/polaroid-shots'
  | 'multimedia/progress-indicator'
  | 'multimedia/projector'
  | 'multimedia/radio'
  | 'multimedia/random'
  | 'multimedia/raw-image'
  | 'multimedia/record-player'
  | 'multimedia/rotate-camera'
  | 'multimedia/rotate-left'
  | 'multimedia/rotate-right'
  | 'multimedia/save-to-list'
  | 'multimedia/saxophone'
  | 'multimedia/scale-2'
  | 'multimedia/screen-reader'
  | 'multimedia/screen-sharing-2'
  | 'multimedia/screen-sharing-off-2'
  | 'multimedia/screen-touch'
  | 'multimedia/sd-card'
  | 'multimedia/selfie'
  | 'multimedia/selfie-2'
  | 'multimedia/sharpen'
  | 'multimedia/sound'
  | 'multimedia/sound-wave'
  | 'multimedia/soundwave'
  | 'multimedia/sparks'
  | 'multimedia/speaker'
  | 'multimedia/speaker-2'
  | 'multimedia/sport-mode'
  | 'multimedia/sticker'
  | 'multimedia/subtitles'
  | 'multimedia/sun'
  | 'multimedia/tape'
  | 'multimedia/temperature'
  | 'multimedia/ticket'
  | 'multimedia/tool-blur'
  | 'multimedia/tripod'
  | 'multimedia/trumpet'
  | 'multimedia/vibrance'
  | 'multimedia/video'
  | 'multimedia/video-camera'
  | 'multimedia/video-gallery'
  | 'multimedia/video-gallery-2'
  | 'multimedia/video-off'
  | 'multimedia/video-player'
  | 'multimedia/video-playlist'
  | 'multimedia/vignette'
  | 'multimedia/violin'
  | 'multimedia/volume'
  | 'multimedia/volume-2'
  | 'multimedia/volume-down'
  | 'multimedia/volume-mute'
  | 'multimedia/volume-off'
  | 'multimedia/volume-up'
  | 'multimedia/white-balance'
  | 'shopping/a-chart'
  | 'shopping/add-to-cart'
  | 'shopping/add-to-cart-2'
  | 'shopping/award'
  | 'shopping/bag-16'
  | 'shopping/bag-17'
  | 'shopping/bag-20'
  | 'shopping/bag-add-18'
  | 'shopping/bag-add-21'
  | 'shopping/bag-delivery'
  | 'shopping/bag-edit'
  | 'shopping/bag-remove-19'
  | 'shopping/bag-remove-22'
  | 'shopping/bag-time'
  | 'shopping/barcode'
  | 'shopping/barcode-qr'
  | 'shopping/barcode-scan'
  | 'shopping/basket'
  | 'shopping/basket-add'
  | 'shopping/basket-edit'
  | 'shopping/basket-favorite'
  | 'shopping/basket-remove'
  | 'shopping/basket-search'
  | 'shopping/basket-share'
  | 'shopping/basket-simple'
  | 'shopping/basket-simple-add'
  | 'shopping/basket-simple-remove'
  | 'shopping/basket-update'
  | 'shopping/bill'
  | 'shopping/billboard'
  | 'shopping/bitcoin'
  | 'shopping/board'
  | 'shopping/box'
  | 'shopping/box-2'
  | 'shopping/box-3d-50'
  | 'shopping/box-3d-67'
  | 'shopping/box-ribbon'
  | 'shopping/businessman-04'
  | 'shopping/card-edit'
  | 'shopping/card-favorite'
  | 'shopping/card-remove'
  | 'shopping/card-update'
  | 'shopping/cart'
  | 'shopping/cart-add'
  | 'shopping/cart-add-9'
  | 'shopping/cart-favorite'
  | 'shopping/cart-full'
  | 'shopping/cart-refresh'
  | 'shopping/cart-remove'
  | 'shopping/cart-remove-9'
  | 'shopping/cart-return'
  | 'shopping/cart-simple-add'
  | 'shopping/cart-simple-remove'
  | 'shopping/cart-speed'
  | 'shopping/cash-register'
  | 'shopping/contactless-card'
  | 'shopping/coupon'
  | 'shopping/credit-card'
  | 'shopping/credit-card-in'
  | 'shopping/credit-locked'
  | 'shopping/currency-dollar'
  | 'shopping/currency-euro'
  | 'shopping/currency-exchange'
  | 'shopping/currency-exchange-2'
  | 'shopping/currency-pound'
  | 'shopping/currency-yen'
  | 'shopping/customer-support'
  | 'shopping/cut'
  | 'shopping/delivery'
  | 'shopping/delivery-2'
  | 'shopping/delivery-3'
  | 'shopping/delivery-fast'
  | 'shopping/delivery-time'
  | 'shopping/delivery-track'
  | 'shopping/discount-2'
  | 'shopping/farmer-market'
  | 'shopping/hand-card'
  | 'shopping/cheque'
  | 'shopping/cheque-2'
  | 'shopping/cheque-3'
  | 'shopping/label'
  | 'shopping/lifering'
  | 'shopping/list'
  | 'shopping/market-music'
  | 'shopping/market-play'
  | 'shopping/mobile-banking'
  | 'shopping/mobile-card'
  | 'shopping/mobile-cart'
  | 'shopping/mobile-touch'
  | 'shopping/money-transfer'
  | 'shopping/new'
  | 'shopping/newsletter'
  | 'shopping/online-banking'
  | 'shopping/pallet'
  | 'shopping/pallet-stacked-boxes'
  | 'shopping/payment-method'
  | 'shopping/percent-sign'
  | 'shopping/percentage-38'
  | 'shopping/personal-trainer'
  | 'shopping/pos'
  | 'shopping/present'
  | 'shopping/receipt'
  | 'shopping/receipt-list-42'
  | 'shopping/receipt-list-43'
  | 'shopping/refund'
  | 'shopping/round-dollar'
  | 'shopping/round-euro'
  | 'shopping/round-pound'
  | 'shopping/round-yen'
  | 'shopping/sale'
  | 'shopping/scale-4'
  | 'shopping/shipping-container'
  | 'shopping/shop'
  | 'shopping/shop-location'
  | 'shopping/shopping-bag'
  | 'shopping/shopping-cart'
  | 'shopping/shopping-cart-2'
  | 'shopping/shopping-label'
  | 'shopping/shopping-tag'
  | 'shopping/sign-24h'
  | 'shopping/sign-board'
  | 'shopping/sign-closed'
  | 'shopping/sign-open'
  | 'shopping/size-large'
  | 'shopping/size-medium'
  | 'shopping/size-small'
  | 'shopping/stock-2'
  | 'shopping/stock-market'
  | 'shopping/storage-unit'
  | 'shopping/store'
  | 'shopping/support'
  | 'shopping/tag'
  | 'shopping/tag-add'
  | 'shopping/tag-cut'
  | 'shopping/tag-check'
  | 'shopping/tag-loyalty'
  | 'shopping/tag-remove'
  | 'shopping/tag-sale'
  | 'shopping/tags-stack'
  | 'shopping/track-delivery'
  | 'shopping/virtual-assistant-2'
  | 'shopping/wallet'
  | 'shopping/wallet-43'
  | 'shopping/wallet-44'
  | 'technology/3d-printing'
  | 'technology/ai'
  | 'technology/ai-generated-img'
  | 'technology/algorithm'
  | 'technology/android'
  | 'technology/antenna'
  | 'technology/api'
  | 'technology/app-services'
  | 'technology/apple'
  | 'technology/artificial-brain'
  | 'technology/artificial-intelligence'
  | 'technology/audio-jack'
  | 'technology/augmented-reality'
  | 'technology/automated-logistics'
  | 'technology/baby-monitor'
  | 'technology/battery-level'
  | 'technology/binary-code'
  | 'technology/block'
  | 'technology/blockchain'
  | 'technology/cable'
  | 'technology/cctv'
  | 'technology/cd-reader'
  | 'technology/cloud-mining'
  | 'technology/computer'
  | 'technology/computer-monitor'
  | 'technology/connection'
  | 'technology/contactless'
  | 'technology/content-360deg'
  | 'technology/content-delivery'
  | 'technology/control-panel'
  | 'technology/controller'
  | 'technology/controller-2'
  | 'technology/cpu'
  | 'technology/cryptography'
  | 'technology/cyborg'
  | 'technology/decentralize'
  | 'technology/decision-process'
  | 'technology/device-connection'
  | 'technology/digital-image'
  | 'technology/digital-key'
  | 'technology/disk'
  | 'technology/disk-reader'
  | 'technology/drone'
  | 'technology/drone-2'
  | 'technology/e-reader'
  | 'technology/earbuds'
  | 'technology/electronic-circuit'
  | 'technology/engine-start'
  | 'technology/eye-recognition'
  | 'technology/face-recognition'
  | 'technology/firewall'
  | 'technology/gaming-console'
  | 'technology/gaming-controller'
  | 'technology/gopro'
  | 'technology/graphics-tablet'
  | 'technology/hacker'
  | 'technology/hair-clipper'
  | 'technology/handheld-console'
  | 'technology/hdmi'
  | 'technology/headphones'
  | 'technology/headphones-2'
  | 'technology/headphones-3'
  | 'technology/headset'
  | 'technology/humanoid'
  | 'technology/hybrid-car'
  | 'technology/charger-cable'
  | 'technology/chat-bot'
  | 'technology/keyboard'
  | 'technology/keyboard-hide'
  | 'technology/keyboard-mouse'
  | 'technology/keyboard-wired'
  | 'technology/keyboard-wireless'
  | 'technology/l-add'
  | 'technology/l-check'
  | 'technology/l-location'
  | 'technology/l-remove'
  | 'technology/l-search'
  | 'technology/l-security'
  | 'technology/l-settings'
  | 'technology/l-sync'
  | 'technology/l-system-update'
  | 'technology/landscape-orientation'
  | 'technology/laptop'
  | 'technology/laptop-1'
  | 'technology/laptop-2'
  | 'technology/license-key'
  | 'technology/live-streaming'
  | 'technology/lock-landscape'
  | 'technology/lock-orientation'
  | 'technology/lock-portrait'
  | 'technology/logic'
  | 'technology/machine-learning'
  | 'technology/media-player'
  | 'technology/messaging'
  | 'technology/metrics'
  | 'technology/mic'
  | 'technology/mic-2'
  | 'technology/migration'
  | 'technology/mobile-banking'
  | 'technology/mobile-chat'
  | 'technology/mobile-phone'
  | 'technology/mouse'
  | 'technology/mouse-2'
  | 'technology/music-player'
  | 'technology/navigation'
  | 'technology/nodes'
  | 'technology/offline'
  | 'technology/online-banking'
  | 'technology/open-ai'
  | 'technology/p-add'
  | 'technology/p-edit'
  | 'technology/p-heart'
  | 'technology/p-check'
  | 'technology/p-location'
  | 'technology/p-remove'
  | 'technology/p-search'
  | 'technology/p-settings'
  | 'technology/p-share'
  | 'technology/p-sync'
  | 'technology/p-system-update'
  | 'technology/p-time'
  | 'technology/parking-sensors'
  | 'technology/pattern-recognition'
  | 'technology/pc'
  | 'technology/pc-monitor'
  | 'technology/pc-mouse'
  | 'technology/pc-play-media'
  | 'technology/pci-card'
  | 'technology/phone-button'
  | 'technology/phone-camera-back'
  | 'technology/phone-camera-front'
  | 'technology/phone-dock'
  | 'technology/phone-charging'
  | 'technology/phone-charging-2'
  | 'technology/phone-charging-3'
  | 'technology/phone-toolbar'
  | 'technology/plug'
  | 'technology/plug-2'
  | 'technology/print'
  | 'technology/printer'
  | 'technology/printer-p'
  | 'technology/printer-p-2'
  | 'technology/projector'
  | 'technology/ram'
  | 'technology/ram-2'
  | 'technology/reading-tablet'
  | 'technology/redmine'
  | 'technology/remote-control'
  | 'technology/robot-cleaner'
  | 'technology/robotic-arm'
  | 'technology/router'
  | 'technology/satellite'
  | 'technology/satellite-dish'
  | 'technology/screen-reader'
  | 'technology/screen-rotation'
  | 'technology/screen-sharing-2'
  | 'technology/screen-sharing-off-2'
  | 'technology/send-to-phone'
  | 'technology/sensor'
  | 'technology/server'
  | 'technology/server-rack'
  | 'technology/signal'
  | 'technology/sim-card'
  | 'technology/smart-house'
  | 'technology/smartphone'
  | 'technology/smartwatch'
  | 'technology/socket'
  | 'technology/socket-europe-1'
  | 'technology/socket-europe-2'
  | 'technology/socket-uk'
  | 'technology/sparks'
  | 'technology/ssd'
  | 'technology/sync-devices'
  | 'technology/system-update'
  | 'technology/tablet'
  | 'technology/tablet-2'
  | 'technology/tablet-charging'
  | 'technology/tablet-toolbar'
  | 'technology/three-dimensional-object'
  | 'technology/three-dimensional-world'
  | 'technology/traffic'
  | 'technology/transactions'
  | 'technology/translation'
  | 'technology/tv'
  | 'technology/tv-stand'
  | 'technology/usb'
  | 'technology/video-off'
  | 'technology/video-player'
  | 'technology/vintage-computer'
  | 'technology/vintage-tv'
  | 'technology/virtual-assistant'
  | 'technology/virtual-assistant-2'
  | 'technology/virtual-environment'
  | 'technology/virtual-reality'
  | 'technology/voice-recognition'
  | 'technology/vpn'
  | 'technology/vr-controller'
  | 'technology/vr-headset'
  | 'technology/watch'
  | 'technology/watch-2'
  | 'technology/webcam'
  | 'technology/webcam-2'
  | 'technology/wifi'
  | 'technology/wifi-2'
  | 'technology/wifi-off'
  | 'technology/wifi-protected'
  | 'technology/wifi-router'
  | 'technology/wireless-charging'
  | 'transportation/air-baloon'
  | 'transportation/airbag'
  | 'transportation/airplane'
  | 'transportation/alien-33'
  | 'transportation/anchor'
  | 'transportation/baby-car-seat'
  | 'transportation/battery-level'
  | 'transportation/bike'
  | 'transportation/bike-bmx'
  | 'transportation/boat'
  | 'transportation/boat-front'
  | 'transportation/boat-small-02'
  | 'transportation/boat-small-03'
  | 'transportation/brakes'
  | 'transportation/bus'
  | 'transportation/bus-front-10'
  | 'transportation/bus-front-12'
  | 'transportation/car'
  | 'transportation/car-2'
  | 'transportation/car-accident'
  | 'transportation/car-connect'
  | 'transportation/car-door'
  | 'transportation/car-front'
  | 'transportation/car-lights'
  | 'transportation/car-parking'
  | 'transportation/car-simple'
  | 'transportation/car-sport'
  | 'transportation/car-ventilation'
  | 'transportation/car-wash'
  | 'transportation/cone'
  | 'transportation/control-panel'
  | 'transportation/cycling'
  | 'transportation/dashboard'
  | 'transportation/delivery'
  | 'transportation/drone'
  | 'transportation/drone-2'
  | 'transportation/engine'
  | 'transportation/engine-start'
  | 'transportation/flight'
  | 'transportation/flip-up'
  | 'transportation/fuel'
  | 'transportation/fuel-2'
  | 'transportation/fuel-electric'
  | 'transportation/helicopter'
  | 'transportation/helmet'
  | 'transportation/hybrid-car'
  | 'transportation/landing'
  | 'transportation/light-traffic'
  | 'transportation/love-car'
  | 'transportation/moto'
  | 'transportation/oil'
  | 'transportation/parking'
  | 'transportation/parking-sensors'
  | 'transportation/plane'
  | 'transportation/power-level'
  | 'transportation/racing-bike'
  | 'transportation/rim'
  | 'transportation/road'
  | 'transportation/road-2'
  | 'transportation/scooter'
  | 'transportation/seat'
  | 'transportation/seatbelt'
  | 'transportation/sensor'
  | 'transportation/shuttle'
  | 'transportation/skateboard'
  | 'transportation/skateboard-2'
  | 'transportation/speedometer'
  | 'transportation/steering-wheel'
  | 'transportation/stop-sign'
  | 'transportation/submarine'
  | 'transportation/take-off'
  | 'transportation/taxi'
  | 'transportation/tractor'
  | 'transportation/train'
  | 'transportation/train-speed'
  | 'transportation/tram'
  | 'transportation/truck-front'
  | 'transportation/trunk'
  | 'transportation/ventilation'
  | 'transportation/vespa'
  | 'transportation/vespa-front'
  | 'transportation/walk'
  | 'transportation/washing-fluid'
  | 'transportation/wheel'
  | 'transportation/wheel-2'
  | 'user-interface/a-chart'
  | 'user-interface/a-chat'
  | 'user-interface/a-tag'
  | 'user-interface/a-tag-add'
  | 'user-interface/a-tag-remove'
  | 'user-interface/access-key'
  | 'user-interface/add'
  | 'user-interface/add-fav'
  | 'user-interface/add-favorite'
  | 'user-interface/add-like'
  | 'user-interface/add-notification'
  | 'user-interface/add-to-cart'
  | 'user-interface/add-to-cart-2'
  | 'user-interface/alarm'
  | 'user-interface/alarm-add'
  | 'user-interface/alarm-disable'
  | 'user-interface/analytics'
  | 'user-interface/app-store'
  | 'user-interface/apps'
  | 'user-interface/archive'
  | 'user-interface/archive-drawer'
  | 'user-interface/at-sign'
  | 'user-interface/attach'
  | 'user-interface/attachment'
  | 'user-interface/b-comment'
  | 'user-interface/b-eye'
  | 'user-interface/b-chart'
  | 'user-interface/backward'
  | 'user-interface/ban'
  | 'user-interface/basket'
  | 'user-interface/battery-charging'
  | 'user-interface/battery-low'
  | 'user-interface/battery-power'
  | 'user-interface/battery-status'
  | 'user-interface/bell'
  | 'user-interface/bin'
  | 'user-interface/blog'
  | 'user-interface/bluetooth'
  | 'user-interface/board-2'
  | 'user-interface/bolt'
  | 'user-interface/book'
  | 'user-interface/bookmark'
  | 'user-interface/bookmark-add'
  | 'user-interface/bookmark-add-2'
  | 'user-interface/bookmark-delete'
  | 'user-interface/bookmark-delete-2'
  | 'user-interface/bookmarks'
  | 'user-interface/bullet-list'
  | 'user-interface/buzz'
  | 'user-interface/c-add'
  | 'user-interface/c-delete'
  | 'user-interface/c-edit'
  | 'user-interface/c-check'
  | 'user-interface/c-info'
  | 'user-interface/c-pulse'
  | 'user-interface/c-question'
  | 'user-interface/c-remove'
  | 'user-interface/c-warning'
  | 'user-interface/calendar'
  | 'user-interface/calendar-2'
  | 'user-interface/calendar-date'
  | 'user-interface/calendar-date-2'
  | 'user-interface/calendar-day-view'
  | 'user-interface/calendar-event'
  | 'user-interface/calendar-event-2'
  | 'user-interface/calendar-event-create'
  | 'user-interface/clear-data'
  | 'user-interface/clock'
  | 'user-interface/cloud'
  | 'user-interface/cloud-forecast'
  | 'user-interface/cogwheel'
  | 'user-interface/comment'
  | 'user-interface/comment-add'
  | 'user-interface/comments'
  | 'user-interface/compare-items'
  | 'user-interface/components'
  | 'user-interface/configuration'
  | 'user-interface/configuration-tool'
  | 'user-interface/configuration-tools'
  | 'user-interface/control-panel'
  | 'user-interface/d-add'
  | 'user-interface/d-delete'
  | 'user-interface/d-edit'
  | 'user-interface/d-chart'
  | 'user-interface/d-check'
  | 'user-interface/d-remove'
  | 'user-interface/dashboard'
  | 'user-interface/data-download'
  | 'user-interface/data-settings'
  | 'user-interface/data-upload'
  | 'user-interface/database'
  | 'user-interface/delete'
  | 'user-interface/delete-forever'
  | 'user-interface/design-system'
  | 'user-interface/disk'
  | 'user-interface/dock-bottom'
  | 'user-interface/dock-left'
  | 'user-interface/dock-right'
  | 'user-interface/dock-top'
  | 'user-interface/download'
  | 'user-interface/drop'
  | 'user-interface/e-add'
  | 'user-interface/e-delete'
  | 'user-interface/e-remove'
  | 'user-interface/edit'
  | 'user-interface/edit-note'
  | 'user-interface/email'
  | 'user-interface/email-open'
  | 'user-interface/empty'
  | 'user-interface/enlarge'
  | 'user-interface/event-confirm'
  | 'user-interface/event-create'
  | 'user-interface/exclamation-mark'
  | 'user-interface/eye'
  | 'user-interface/f-add'
  | 'user-interface/f-comment'
  | 'user-interface/f-dashboard'
  | 'user-interface/f-delete'
  | 'user-interface/f-chat'
  | 'user-interface/f-check'
  | 'user-interface/f-remove'
  | 'user-interface/fav-list'
  | 'user-interface/fav-remove'
  | 'user-interface/favorite'
  | 'user-interface/feedback'
  | 'user-interface/file-add'
  | 'user-interface/file-article'
  | 'user-interface/file-delete'
  | 'user-interface/file-text'
  | 'user-interface/filter'
  | 'user-interface/filter-check'
  | 'user-interface/filter-remove'
  | 'user-interface/filter-tool'
  | 'user-interface/find-replace'
  | 'user-interface/flame'
  | 'user-interface/floors'
  | 'user-interface/floppy-disk'
  | 'user-interface/forward'
  | 'user-interface/full-screen'
  | 'user-interface/fullsize'
  | 'user-interface/funnel'
  | 'user-interface/g-chart'
  | 'user-interface/g-check'
  | 'user-interface/gallery-layout'
  | 'user-interface/gallery-view'
  | 'user-interface/gantt'
  | 'user-interface/gear'
  | 'user-interface/geometry'
  | 'user-interface/grid-interface'
  | 'user-interface/grid-layout'
  | 'user-interface/grid-view'
  | 'user-interface/heart'
  | 'user-interface/hide'
  | 'user-interface/home'
  | 'user-interface/home-2'
  | 'user-interface/home-3'
  | 'user-interface/hot-key'
  | 'user-interface/hotspot'
  | 'user-interface/hourglass'
  | 'user-interface/house'
  | 'user-interface/hyperlink'
  | 'user-interface/hyperlink-broken'
  | 'user-interface/chain'
  | 'user-interface/chart'
  | 'user-interface/chat'
  | 'user-interface/check'
  | 'user-interface/check-all'
  | 'user-interface/check-double'
  | 'user-interface/check-in'
  | 'user-interface/check-list'
  | 'user-interface/check-out'
  | 'user-interface/check-single'
  | 'user-interface/checkbox-btn'
  | 'user-interface/checkbox-btn-checked'
  | 'user-interface/chemistry'
  | 'user-interface/i-add'
  | 'user-interface/i-delete'
  | 'user-interface/i-edit'
  | 'user-interface/i-check'
  | 'user-interface/i-remove'
  | 'user-interface/incognito'
  | 'user-interface/increase'
  | 'user-interface/infinite'
  | 'user-interface/info'
  | 'user-interface/key'
  | 'user-interface/label'
  | 'user-interface/layout'
  | 'user-interface/layout-grid'
  | 'user-interface/leaf'
  | 'user-interface/leave'
  | 'user-interface/letter'
  | 'user-interface/lifering'
  | 'user-interface/light-control'
  | 'user-interface/like'
  | 'user-interface/link'
  | 'user-interface/lock'
  | 'user-interface/log-out'
  | 'user-interface/magnifier'
  | 'user-interface/magnifier-zoom-in'
  | 'user-interface/magnifier-zoom-out'
  | 'user-interface/mail'
  | 'user-interface/megaphone'
  | 'user-interface/menu'
  | 'user-interface/menu-2'
  | 'user-interface/menu-3'
  | 'user-interface/menu-4'
  | 'user-interface/menu-6'
  | 'user-interface/menu-7'
  | 'user-interface/menu-8'
  | 'user-interface/menu-dots'
  | 'user-interface/metrics'
  | 'user-interface/mirror-tablet-phone'
  | 'user-interface/n-edit'
  | 'user-interface/n-check'
  | 'user-interface/network-communication'
  | 'user-interface/network-connection'
  | 'user-interface/networking'
  | 'user-interface/new-notification'
  | 'user-interface/news'
  | 'user-interface/no-results'
  | 'user-interface/note'
  | 'user-interface/notification'
  | 'user-interface/notification-2'
  | 'user-interface/o-check'
  | 'user-interface/o-warning'
  | 'user-interface/offline'
  | 'user-interface/opening-times'
  | 'user-interface/options'
  | 'user-interface/p-chart'
  | 'user-interface/padlock'
  | 'user-interface/padlock-unlocked'
  | 'user-interface/paragraph'
  | 'user-interface/password'
  | 'user-interface/pen'
  | 'user-interface/pen-2'
  | 'user-interface/pencil'
  | 'user-interface/phone'
  | 'user-interface/phone-call'
  | 'user-interface/phone-call-end'
  | 'user-interface/plant-leaf'
  | 'user-interface/playlist'
  | 'user-interface/preferences'
  | 'user-interface/present'
  | 'user-interface/privacy'
  | 'user-interface/privacy-settings'
  | 'user-interface/progress-2'
  | 'user-interface/progress-indicator'
  | 'user-interface/question-mark'
  | 'user-interface/questionnaire'
  | 'user-interface/r-chat'
  | 'user-interface/radio-btn'
  | 'user-interface/radio-btn-checked'
  | 'user-interface/remove'
  | 'user-interface/remove-fav'
  | 'user-interface/remove-favorite'
  | 'user-interface/remove-like'
  | 'user-interface/roadmap'
  | 'user-interface/s-add'
  | 'user-interface/s-ban'
  | 'user-interface/s-delete'
  | 'user-interface/s-edit'
  | 'user-interface/s-check'
  | 'user-interface/s-info'
  | 'user-interface/s-pulse'
  | 'user-interface/s-question'
  | 'user-interface/s-remove'
  | 'user-interface/s-warning'
  | 'user-interface/save-for-later'
  | 'user-interface/save-to-list'
  | 'user-interface/saved-items'
  | 'user-interface/screen-enlarge'
  | 'user-interface/screen-expand'
  | 'user-interface/screen-maximize'
  | 'user-interface/screen-sharing-2'
  | 'user-interface/screen-sharing-off-2'
  | 'user-interface/search'
  | 'user-interface/search-content'
  | 'user-interface/search-zoom-in'
  | 'user-interface/search-zoom-out'
  | 'user-interface/security'
  | 'user-interface/segmentation'
  | 'user-interface/select'
  | 'user-interface/send'
  | 'user-interface/send-message'
  | 'user-interface/settings'
  | 'user-interface/settings-gear'
  | 'user-interface/settings-wheel'
  | 'user-interface/setup-options'
  | 'user-interface/setup-preferences'
  | 'user-interface/setup-tools'
  | 'user-interface/share'
  | 'user-interface/sharing'
  | 'user-interface/shop'
  | 'user-interface/shopping-bag'
  | 'user-interface/shopping-cart'
  | 'user-interface/shopping-cart-2'
  | 'user-interface/shopping-label'
  | 'user-interface/shopping-tag'
  | 'user-interface/sidebar'
  | 'user-interface/slide-left'
  | 'user-interface/slide-right'
  | 'user-interface/social-sharing'
  | 'user-interface/sort-tool'
  | 'user-interface/spaceship'
  | 'user-interface/speedometer'
  | 'user-interface/stack'
  | 'user-interface/star'
  | 'user-interface/star-rate'
  | 'user-interface/stopwatch'
  | 'user-interface/support'
  | 'user-interface/survey'
  | 'user-interface/switches'
  | 'user-interface/system-configuration'
  | 'user-interface/system-preferences'
  | 'user-interface/t-add'
  | 'user-interface/t-delete'
  | 'user-interface/t-remove'
  | 'user-interface/table-layout'
  | 'user-interface/table-move'
  | 'user-interface/table-slide'
  | 'user-interface/tag'
  | 'user-interface/tags-stack'
  | 'user-interface/target'
  | 'user-interface/telephone'
  | 'user-interface/time-alarm'
  | 'user-interface/time-clock'
  | 'user-interface/time-machine'
  | 'user-interface/timeline'
  | 'user-interface/toggle'
  | 'user-interface/translation'
  | 'user-interface/trash'
  | 'user-interface/trash-can'
  | 'user-interface/unlink'
  | 'user-interface/unlocked'
  | 'user-interface/upload'
  | 'user-interface/url'
  | 'user-interface/verified'
  | 'user-interface/video-gallery'
  | 'user-interface/view'
  | 'user-interface/virtual-assistant-2'
  | 'user-interface/warning-sign'
  | 'user-interface/web-hyperlink'
  | 'user-interface/web-link'
  | 'user-interface/web-url'
  | 'user-interface/webpage'
  | 'user-interface/widget'
  | 'user-interface/window-add'
  | 'user-interface/window-delete'
  | 'user-interface/wireframe'
  | 'user-interface/wrench'
  | 'user-interface/wrench-tool'
  | 'user-interface/zoom'
  | 'user-interface/zoom-in'
  | 'user-interface/zoom-out'
  | 'users/accessibility'
  | 'users/account'
  | 'users/address-book'
  | 'users/contact'
  | 'users/contact-list'
  | 'users/contacts'
  | 'users/couple-gay'
  | 'users/couple-lesbian'
  | 'users/diaper-changing-area'
  | 'users/doctor'
  | 'users/exchange'
  | 'users/face-man'
  | 'users/face-woman'
  | 'users/family'
  | 'users/family-roof'
  | 'users/farmer'
  | 'users/female-figure'
  | 'users/female-sign'
  | 'users/file-shared'
  | 'users/file-user'
  | 'users/folder-shared'
  | 'users/folder-user'
  | 'users/gathering-restrictions'
  | 'users/grandparent'
  | 'users/hacker'
  | 'users/hair-man'
  | 'users/hair-woman'
  | 'users/humanoid'
  | 'users/child'
  | 'users/info-point'
  | 'users/interview'
  | 'users/joint-account'
  | 'users/male-sign'
  | 'users/man'
  | 'users/man-arrow-down'
  | 'users/man-arrow-up'
  | 'users/man-profile'
  | 'users/meeting'
  | 'users/mickey-mouse'
  | 'users/miner'
  | 'users/mobile-contact'
  | 'users/negative-judgement'
  | 'users/no-contact'
  | 'users/office-badge'
  | 'users/office-pass'
  | 'users/parenting'
  | 'users/payee'
  | 'users/payor'
  | 'users/people-network'
  | 'users/police-officer'
  | 'users/positive-judgement'
  | 'users/pregnant-woman'
  | 'users/privacy-policy'
  | 'users/profile'
  | 'users/property'
  | 'users/reading'
  | 'users/search-user'
  | 'users/security-gate'
  | 'users/security-officer'
  | 'users/social-distancing'
  | 'users/standing-man'
  | 'users/standing-woman'
  | 'users/stay-home'
  | 'users/team'
  | 'users/toilette'
  | 'users/user'
  | 'users/user-2'
  | 'users/user-add'
  | 'users/user-bubble'
  | 'users/user-c-frame'
  | 'users/user-c-frame-2'
  | 'users/user-c-frame-3'
  | 'users/user-create'
  | 'users/user-delete'
  | 'users/user-delete-cross'
  | 'users/user-delete-line'
  | 'users/user-edit'
  | 'users/user-focus'
  | 'users/user-group'
  | 'users/user-heart'
  | 'users/user-check'
  | 'users/user-list'
  | 'users/user-location'
  | 'users/user-location-2'
  | 'users/user-lock'
  | 'users/user-new'
  | 'users/user-remove'
  | 'users/user-s-frame'
  | 'users/user-s-frame-2'
  | 'users/user-s-frame-3'
  | 'users/user-search'
  | 'users/user-share'
  | 'users/user-star'
  | 'users/user-sync'
  | 'users/user-time'
  | 'users/user-wearing-glasses'
  | 'users/users'
  | 'users/users-add'
  | 'users/users-heart'
  | 'users/users-check'
  | 'users/users-location'
  | 'users/users-lock'
  | 'users/users-meeting'
  | 'users/users-mm'
  | 'users/users-remove'
  | 'users/users-wm'
  | 'users/users-ww'
  | 'users/virtual-assistant-2'
  | 'users/voice-record'
  | 'users/wc-sign'
  | 'users/wheelchair'
  | 'users/woman'
  | 'users/woman-arrow-down'
  | 'users/woman-arrow-up'
  | 'users/woman-man'
  | 'users/woman-profile'
  | 'users/work-badge'

export const iconSizeMasks: Record<GeneratedIconName, number> = {
  'arrows/arrow-bottom-left': 63,
  'arrows/arrow-bottom-right': 63,
  'arrows/arrow-down': 63,
  'arrows/arrow-down-2': 63,
  'arrows/arrow-down-3': 63,
  'arrows/arrow-e': 63,
  'arrows/arrow-left': 63,
  'arrows/arrow-left-2': 63,
  'arrows/arrow-left-3': 63,
  'arrows/arrow-n': 63,
  'arrows/arrow-right': 63,
  'arrows/arrow-right-2': 63,
  'arrows/arrow-right-3': 63,
  'arrows/arrow-s': 63,
  'arrows/arrow-tool': 63,
  'arrows/arrow-top-left': 63,
  'arrows/arrow-top-right': 63,
  'arrows/arrow-up': 63,
  'arrows/arrow-up-2': 63,
  'arrows/arrow-up-3': 63,
  'arrows/arrow-w': 63,
  'arrows/backward': 63,
  'arrows/block-down': 63,
  'arrows/block-left': 63,
  'arrows/block-right': 63,
  'arrows/block-up': 63,
  'arrows/box-arrow-bottom-left': 63,
  'arrows/box-arrow-bottom-right': 63,
  'arrows/box-arrow-top-left': 63,
  'arrows/box-arrow-top-right': 63,
  'arrows/box-caret-down': 63,
  'arrows/box-caret-left': 63,
  'arrows/box-caret-right': 63,
  'arrows/box-caret-up': 63,
  'arrows/box-ctrl-down': 63,
  'arrows/box-ctrl-left': 63,
  'arrows/box-ctrl-right': 63,
  'arrows/box-ctrl-up': 63,
  'arrows/circle-caret-down': 63,
  'arrows/circle-caret-left': 63,
  'arrows/circle-caret-right': 63,
  'arrows/circle-caret-up': 63,
  'arrows/circle-ctrl-down': 63,
  'arrows/circle-ctrl-left': 63,
  'arrows/circle-ctrl-right': 63,
  'arrows/circle-ctrl-up': 63,
  'arrows/conversion': 63,
  'arrows/corner-bottom-left': 63,
  'arrows/corner-bottom-right': 63,
  'arrows/corner-top-left': 63,
  'arrows/corner-top-right': 63,
  'arrows/ctrl-backward': 63,
  'arrows/ctrl-down': 63,
  'arrows/ctrl-forward': 63,
  'arrows/ctrl-left': 63,
  'arrows/ctrl-right': 63,
  'arrows/ctrl-up': 63,
  'arrows/curved-arrow-down': 63,
  'arrows/curved-arrow-left': 63,
  'arrows/curved-arrow-right': 63,
  'arrows/cycle': 63,
  'arrows/data-download': 63,
  'arrows/data-upload': 63,
  'arrows/delete-key': 63,
  'arrows/direction-down': 63,
  'arrows/direction-left': 63,
  'arrows/direction-right': 63,
  'arrows/direction-up': 63,
  'arrows/double-arrow-left': 63,
  'arrows/double-arrow-right': 63,
  'arrows/down-arrow': 63,
  'arrows/download': 63,
  'arrows/download-data': 63,
  'arrows/download-file': 63,
  'arrows/eject': 63,
  'arrows/enlarge': 63,
  'arrows/enlarge-h': 63,
  'arrows/enter': 63,
  'arrows/expand': 63,
  'arrows/expand-2': 63,
  'arrows/expand-h': 63,
  'arrows/expand-window': 63,
  'arrows/export': 63,
  'arrows/file-download': 63,
  'arrows/file-upload': 63,
  'arrows/format-left': 63,
  'arrows/format-right': 63,
  'arrows/forward': 63,
  'arrows/fullscreen': 63,
  'arrows/increase': 63,
  'arrows/input': 63,
  'arrows/launch': 63,
  'arrows/launch-app': 63,
  'arrows/left-arrow': 63,
  'arrows/log-in': 63,
  'arrows/log-out': 63,
  'arrows/logout': 63,
  'arrows/maximize-area': 63,
  'arrows/move-down': 63,
  'arrows/move-layer-down': 63,
  'arrows/move-layer-left': 63,
  'arrows/move-layer-right': 63,
  'arrows/move-layer-up': 63,
  'arrows/move-left': 63,
  'arrows/move-right': 63,
  'arrows/move-up': 63,
  'arrows/nav-down': 63,
  'arrows/nav-left': 63,
  'arrows/nav-right': 63,
  'arrows/nav-up': 63,
  'arrows/open-in-browser': 63,
  'arrows/pointing-down': 63,
  'arrows/pointing-left': 63,
  'arrows/pointing-right': 63,
  'arrows/pointing-up': 63,
  'arrows/refresh': 63,
  'arrows/reload': 63,
  'arrows/reply': 63,
  'arrows/reply-arrow': 63,
  'arrows/resize-x': 63,
  'arrows/resize-y': 63,
  'arrows/respond-arrow': 63,
  'arrows/right-arrow': 63,
  'arrows/share': 63,
  'arrows/sharing': 63,
  'arrows/sign-down': 63,
  'arrows/sign-left': 63,
  'arrows/sign-right': 63,
  'arrows/sign-up': 63,
  'arrows/slide-left': 63,
  'arrows/slide-right': 63,
  'arrows/social-sharing': 63,
  'arrows/swap-horizontal': 63,
  'arrows/swap-vertical': 63,
  'arrows/system-update': 63,
  'arrows/traffic': 63,
  'arrows/transaction': 63,
  'arrows/triangle-down': 63,
  'arrows/triangle-left': 63,
  'arrows/triangle-line-down': 63,
  'arrows/triangle-line-left': 63,
  'arrows/triangle-line-right': 63,
  'arrows/triangle-line-up': 63,
  'arrows/triangle-right': 63,
  'arrows/triangle-up': 63,
  'arrows/turn-e': 63,
  'arrows/turn-n': 63,
  'arrows/turn-s': 63,
  'arrows/turn-w': 63,
  'arrows/up-arrow': 63,
  'arrows/upload': 63,
  'arrows/upload-data': 63,
  'arrows/upload-file': 63,
  'business-finance/address-book': 60,
  'business-finance/agenda': 62,
  'business-finance/algorithm': 62,
  'business-finance/app-services': 60,
  'business-finance/archery-target': 62,
  'business-finance/atm': 62,
  'business-finance/award-49': 62,
  'business-finance/badge': 62,
  'business-finance/bank-statement': 60,
  'business-finance/bill': 62,
  'business-finance/bitcoin': 62,
  'business-finance/block': 63,
  'business-finance/blockchain': 62,
  'business-finance/board-27': 62,
  'business-finance/board-28': 62,
  'business-finance/board-29': 60,
  'business-finance/board-30': 60,
  'business-finance/books': 62,
  'business-finance/briefcase-24': 63,
  'business-finance/briefcase-25': 62,
  'business-finance/briefcase-26': 62,
  'business-finance/bulb-61': 62,
  'business-finance/bulb-62': 62,
  'business-finance/bulb-63': 62,
  'business-finance/business-agent': 60,
  'business-finance/business-contact-85': 60,
  'business-finance/business-contact-86': 56,
  'business-finance/business-contact-87': 56,
  'business-finance/business-contact-88': 56,
  'business-finance/businessman-03': 62,
  'business-finance/businessman-04': 62,
  'business-finance/calculator': 62,
  'business-finance/candlestick-chart': 63,
  'business-finance/card-edit': 62,
  'business-finance/card-favorite': 62,
  'business-finance/card-remove': 62,
  'business-finance/card-update': 60,
  'business-finance/certificate': 62,
  'business-finance/cloud-mining': 62,
  'business-finance/cockade': 62,
  'business-finance/coins': 62,
  'business-finance/conference-room': 62,
  'business-finance/connect': 62,
  'business-finance/contactless-card': 60,
  'business-finance/contacts': 62,
  'business-finance/copyright': 63,
  'business-finance/credit-card': 62,
  'business-finance/credit-card-in': 62,
  'business-finance/credit-locked': 60,
  'business-finance/crypto-wallet': 62,
  'business-finance/currency-dollar': 62,
  'business-finance/currency-euro': 62,
  'business-finance/currency-exchange': 62,
  'business-finance/currency-exchange-2': 60,
  'business-finance/currency-pound': 62,
  'business-finance/currency-yen': 62,
  'business-finance/debt': 60,
  'business-finance/decentralize': 62,
  'business-finance/decision-process': 60,
  'business-finance/dice': 63,
  'business-finance/factory': 62,
  'business-finance/globe': 62,
  'business-finance/goal-65': 62,
  'business-finance/gold': 60,
  'business-finance/hammer': 62,
  'business-finance/hand-card': 60,
  'business-finance/handout': 62,
  'business-finance/handshake': 62,
  'business-finance/hat': 62,
  'business-finance/hierarchy-53': 62,
  'business-finance/hierarchy-54': 60,
  'business-finance/hierarchy-55': 60,
  'business-finance/hierarchy-56': 60,
  'business-finance/chart': 63,
  'business-finance/chart-bar-32': 62,
  'business-finance/chart-bar-33': 60,
  'business-finance/chart-growth': 62,
  'business-finance/chart-pie-35': 62,
  'business-finance/chart-pie-36': 62,
  'business-finance/cheque': 62,
  'business-finance/chess-knight': 62,
  'business-finance/chess-tower': 62,
  'business-finance/info-point': 62,
  'business-finance/interview': 60,
  'business-finance/joint-account': 60,
  'business-finance/laptop-71': 60,
  'business-finance/laptop-72': 60,
  'business-finance/laptop-91': 56,
  'business-finance/law': 60,
  'business-finance/line-chart': 63,
  'business-finance/loan': 60,
  'business-finance/logic': 60,
  'business-finance/math': 62,
  'business-finance/miner': 62,
  'business-finance/mobile-banking': 60,
  'business-finance/mobile-card': 60,
  'business-finance/money-11': 62,
  'business-finance/money-12': 62,
  'business-finance/money-13': 62,
  'business-finance/money-bag': 62,
  'business-finance/money-coins': 60,
  'business-finance/money-growth': 60,
  'business-finance/money-time': 60,
  'business-finance/money-transfer': 60,
  'business-finance/mortgage': 60,
  'business-finance/name-card': 62,
  'business-finance/negative-judgement': 60,
  'business-finance/net': 62,
  'business-finance/new-construction': 62,
  'business-finance/nodes': 62,
  'business-finance/notes': 62,
  'business-finance/office': 62,
  'business-finance/office-badge': 62,
  'business-finance/office-chair': 62,
  'business-finance/office-pass': 63,
  'business-finance/online-banking': 60,
  'business-finance/payee': 62,
  'business-finance/payment': 60,
  'business-finance/payment-method': 62,
  'business-finance/payor': 62,
  'business-finance/percentage-38': 60,
  'business-finance/percentage-39': 62,
  'business-finance/personal-trainer': 62,
  'business-finance/pig': 60,
  'business-finance/pin': 62,
  'business-finance/plug': 63,
  'business-finance/pos': 60,
  'business-finance/positive-judgement': 60,
  'business-finance/presentation': 62,
  'business-finance/privacy-policy': 62,
  'business-finance/progress': 62,
  'business-finance/puzzle-09': 62,
  'business-finance/puzzle-10': 62,
  'business-finance/ranking': 62,
  'business-finance/rate-down': 60,
  'business-finance/rate-up': 60,
  'business-finance/refund': 60,
  'business-finance/round-dollar': 60,
  'business-finance/round-euro': 60,
  'business-finance/round-pound': 60,
  'business-finance/round-yen': 60,
  'business-finance/safe': 62,
  'business-finance/savings': 60,
  'business-finance/scale': 60,
  'business-finance/sign': 62,
  'business-finance/signature': 62,
  'business-finance/statistics': 63,
  'business-finance/stock-market': 62,
  'business-finance/tactic': 62,
  'business-finance/temple': 62,
  'business-finance/tie-01': 62,
  'business-finance/tie-02': 62,
  'business-finance/transaction': 63,
  'business-finance/transactions': 63,
  'business-finance/wallet-43': 62,
  'business-finance/wallet-44': 62,
  'business-finance/wallet-90': 60,
  'desing-development/3d-29': 62,
  'desing-development/3d-model': 62,
  'desing-development/ai-generated-img': 62,
  'desing-development/album': 63,
  'desing-development/align-bottom': 62,
  'desing-development/align-center-horizontal': 62,
  'desing-development/align-center-vertical': 62,
  'desing-development/align-left': 62,
  'desing-development/align-right': 62,
  'desing-development/align-top': 62,
  'desing-development/android': 62,
  'desing-development/angle': 62,
  'desing-development/animation-14': 62,
  'desing-development/animation-31': 62,
  'desing-development/animation-32': 62,
  'desing-development/api': 60,
  'desing-development/app': 62,
  'desing-development/app-store': 62,
  'desing-development/apple': 62,
  'desing-development/apps': 63,
  'desing-development/arrow-tool': 63,
  'desing-development/artboard': 62,
  'desing-development/binary-code': 62,
  'desing-development/blend': 62,
  'desing-development/block': 63,
  'desing-development/blockchain': 62,
  'desing-development/board-2': 60,
  'desing-development/book-bookmark': 62,
  'desing-development/book-bookmark-2': 62,
  'desing-development/book-open': 62,
  'desing-development/book-open-2': 62,
  'desing-development/border': 62,
  'desing-development/border-radius': 62,
  'desing-development/border-width': 62,
  'desing-development/browser-edge': 60,
  'desing-development/browser-edge-legacy': 60,
  'desing-development/browser-firefox': 60,
  'desing-development/browser-chrome': 60,
  'desing-development/browser-ie': 60,
  'desing-development/browser-opera': 60,
  'desing-development/browser-safari': 60,
  'desing-development/brush': 63,
  'desing-development/bucket': 62,
  'desing-development/bullet-list-67': 62,
  'desing-development/bullet-list-68': 62,
  'desing-development/bullet-list-69': 62,
  'desing-development/bullet-list-70': 62,
  'desing-development/button-2': 62,
  'desing-development/canvas': 62,
  'desing-development/cards': 62,
  'desing-development/clone': 62,
  'desing-development/code': 62,
  'desing-development/code-editor': 60,
  'desing-development/collection': 62,
  'desing-development/command': 62,
  'desing-development/compare-items': 63,
  'desing-development/compass': 62,
  'desing-development/components': 62,
  'desing-development/contrast-2': 62,
  'desing-development/copy': 62,
  'desing-development/creative-commons': 62,
  'desing-development/crop': 62,
  'desing-development/css3': 62,
  'desing-development/cursor-48': 62,
  'desing-development/cursor-49': 62,
  'desing-development/cursor-add': 62,
  'desing-development/cursor-grab': 62,
  'desing-development/cursor-load': 62,
  'desing-development/cursor-menu': 62,
  'desing-development/cursor-not-allowed': 62,
  'desing-development/cursor-pointer': 62,
  'desing-development/cursor-text': 62,
  'desing-development/data-table': 62,
  'desing-development/decision-process': 60,
  'desing-development/depth': 62,
  'desing-development/design': 62,
  'desing-development/design-dev': 56,
  'desing-development/design-system': 63,
  'desing-development/digital-image': 62,
  'desing-development/distribute-horizontal': 62,
  'desing-development/distribute-vertical': 62,
  'desing-development/divider': 62,
  'desing-development/drag': 60,
  'desing-development/drop-15': 62,
  'desing-development/duplicate': 63,
  'desing-development/edit-curves': 62,
  'desing-development/edit-levels': 62,
  'desing-development/empty': 63,
  'desing-development/eraser-32': 62,
  'desing-development/filter-organization': 62,
  'desing-development/flip-horizontal': 62,
  'desing-development/flip-vertical': 62,
  'desing-development/floors': 62,
  'desing-development/form': 62,
  'desing-development/frame': 62,
  'desing-development/function': 63,
  'desing-development/geometry': 62,
  'desing-development/git-commit': 62,
  'desing-development/gradient': 62,
  'desing-development/grain-effect': 62,
  'desing-development/graphics-tablet': 62,
  'desing-development/grid-system': 62,
  'desing-development/group': 62,
  'desing-development/hash-mark': 63,
  'desing-development/height-2': 62,
  'desing-development/hot-key': 62,
  'desing-development/html5': 62,
  'desing-development/image': 63,
  'desing-development/image-2': 62,
  'desing-development/img-stack': 62,
  'desing-development/invert-process': 62,
  'desing-development/js-console': 62,
  'desing-development/json-logo': 62,
  'desing-development/ladybug': 62,
  'desing-development/layers': 62,
  'desing-development/layers-2': 63,
  'desing-development/layout': 62,
  'desing-development/layout-11': 62,
  'desing-development/layout-25': 62,
  'desing-development/layout-grid': 63,
  'desing-development/license-key': 60,
  'desing-development/magic-wand': 62,
  'desing-development/magnet': 62,
  'desing-development/markdown': 62,
  'desing-development/marker': 62,
  'desing-development/mask-oval': 62,
  'desing-development/mask-rect': 62,
  'desing-development/measure-02': 62,
  'desing-development/measure-17': 62,
  'desing-development/measure-big': 62,
  'desing-development/microsoft': 60,
  'desing-development/mirror-display': 62,
  'desing-development/mirror-tablet-phone': 63,
  'desing-development/mobile-design': 60,
  'desing-development/mobile-dev': 60,
  'desing-development/mobile-phone': 63,
  'desing-development/mouse': 63,
  'desing-development/mouse-2': 62,
  'desing-development/move': 62,
  'desing-development/move-down-2': 62,
  'desing-development/move-up-2': 62,
  'desing-development/newsletter-dev': 60,
  'desing-development/note': 63,
  'desing-development/note-code': 62,
  'desing-development/octagon': 62,
  'desing-development/octagon-m': 62,
  'desing-development/paint-16': 62,
  'desing-development/paint-37': 62,
  'desing-development/paint-38': 62,
  'desing-development/paint-brush': 62,
  'desing-development/paint-bucket-39': 62,
  'desing-development/paint-bucket-40': 62,
  'desing-development/palette': 62,
  'desing-development/pantone': 62,
  'desing-development/paper-design': 60,
  'desing-development/paper-dev': 60,
  'desing-development/paragraph-2': 62,
  'desing-development/path-exclude': 62,
  'desing-development/path-intersect': 62,
  'desing-development/path-minus': 62,
  'desing-development/path-unite': 62,
  'desing-development/patch-19': 62,
  'desing-development/patch-34': 62,
  'desing-development/pc-mouse': 62,
  'desing-development/pen-01': 62,
  'desing-development/pen-23': 60,
  'desing-development/pen-tool': 60,
  'desing-development/photo-album': 60,
  'desing-development/photo-editor': 60,
  'desing-development/pilcrow': 60,
  'desing-development/plug-2': 60,
  'desing-development/position': 60,
  'desing-development/priority-high': 60,
  'desing-development/priority-highest': 60,
  'desing-development/priority-low': 60,
  'desing-development/priority-lowest': 60,
  'desing-development/priority-normal': 60,
  'desing-development/prototype': 60,
  'desing-development/refresh-02': 60,
  'desing-development/responsive': 56,
  'desing-development/roadmap': 60,
  'desing-development/row-table': 61,
  'desing-development/ruler-pencil': 60,
  'desing-development/scale-2': 60,
  'desing-development/scale-down': 60,
  'desing-development/scale-up': 60,
  'desing-development/scissors': 60,
  'desing-development/scissors-dashed': 60,
  'desing-development/selection': 60,
  'desing-development/shape-adjust': 60,
  'desing-development/shape-arrow': 60,
  'desing-development/shape-circle': 60,
  'desing-development/shape-custom': 60,
  'desing-development/shape-line': 60,
  'desing-development/shape-oval': 60,
  'desing-development/shape-polygon': 60,
  'desing-development/shape-polygon-2': 60,
  'desing-development/shape-rectangle': 60,
  'desing-development/shape-square': 60,
  'desing-development/shape-star': 60,
  'desing-development/shape-triangle': 60,
  'desing-development/shape-triangle-2': 60,
  'desing-development/shapes': 60,
  'desing-development/sharpener': 60,
  'desing-development/sidebar': 61,
  'desing-development/size-large': 60,
  'desing-development/size-medium': 60,
  'desing-development/size-small': 60,
  'desing-development/slice': 60,
  'desing-development/slider': 62,
  'desing-development/space-divider': 62,
  'desing-development/sparks': 63,
  'desing-development/spray-can': 62,
  'desing-development/stack': 63,
  'desing-development/stamp': 62,
  'desing-development/style': 62,
  'desing-development/tablet-mobile': 60,
  'desing-development/texture': 62,
  'desing-development/three-dimensional-object': 63,
  'desing-development/time-machine': 60,
  'desing-development/timeline': 63,
  'desing-development/todo': 62,
  'desing-development/tool-blur': 62,
  'desing-development/tool-hand': 62,
  'desing-development/tool-select': 62,
  'desing-development/transactions': 63,
  'desing-development/transform': 62,
  'desing-development/transform-2d': 62,
  'desing-development/transform-origin': 62,
  'desing-development/transparent': 62,
  'desing-development/type-tool': 62,
  'desing-development/typography': 62,
  'desing-development/ungroup': 62,
  'desing-development/usb': 62,
  'desing-development/vector': 62,
  'desing-development/vibrance': 63,
  'desing-development/wand': 62,
  'desing-development/watch-dev': 60,
  'desing-development/web-design': 60,
  'desing-development/webpage': 63,
  'desing-development/width': 62,
  'desing-development/window-code': 62,
  'desing-development/window-dev': 60,
  'desing-development/window-paragraph': 62,
  'desing-development/window-responsive': 62,
  'desing-development/wireframe': 63,
  'desing-development/zoom': 63,
  'education/abc': 60,
  'education/agenda': 62,
  'education/agenda-bookmark': 62,
  'education/album': 63,
  'education/astronomy': 62,
  'education/atom': 62,
  'education/award-49': 62,
  'education/backpack-57': 62,
  'education/backpack-58': 62,
  'education/basketball': 62,
  'education/biochemistry': 62,
  'education/biology': 62,
  'education/board-27': 62,
  'education/board-51': 62,
  'education/book': 63,
  'education/book-39': 62,
  'education/book-bookmark': 62,
  'education/book-bookmark-2': 62,
  'education/book-open': 60,
  'education/book-open-2': 62,
  'education/bookmark': 63,
  'education/books': 62,
  'education/books-46': 62,
  'education/botany': 62,
  'education/brush': 63,
  'education/bus': 60,
  'education/bus-front-12': 62,
  'education/buzz': 62,
  'education/calculator': 62,
  'education/certificate': 62,
  'education/cockade': 62,
  'education/collection': 62,
  'education/compass': 62,
  'education/design': 62,
  'education/earth-science': 62,
  'education/ecology': 62,
  'education/equation': 63,
  'education/eraser-32': 62,
  'education/eraser-33': 62,
  'education/flask': 62,
  'education/function': 63,
  'education/geometry': 62,
  'education/glasses': 62,
  'education/glasses-2': 62,
  'education/globe': 62,
  'education/globe-2': 62,
  'education/grammar-check': 60,
  'education/hat-3': 62,
  'education/chalkboard': 60,
  'education/chemistry': 63,
  'education/language': 62,
  'education/logic': 60,
  'education/marker': 62,
  'education/math': 62,
  'education/measure-02': 62,
  'education/measure-17': 62,
  'education/measure-big': 62,
  'education/medal': 62,
  'education/medicine': 62,
  'education/microbiology': 62,
  'education/microscope': 62,
  'education/molecule': 62,
  'education/notepad': 62,
  'education/notes': 62,
  'education/notification': 60,
  'education/open-book': 60,
  'education/paper': 62,
  'education/paper-diploma': 62,
  'education/paw': 62,
  'education/pc-play-media': 62,
  'education/pen-01': 62,
  'education/pen-23': 62,
  'education/pen-tool': 62,
  'education/pencil': 62,
  'education/pencil-47': 62,
  'education/pendulum': 62,
  'education/planet': 62,
  'education/potion': 62,
  'education/presentation': 62,
  'education/rat': 62,
  'education/read': 63,
  'education/reading': 60,
  'education/research': 62,
  'education/saved-items': 63,
  'education/school': 62,
  'education/soccer-ball': 62,
  'education/statistics': 63,
  'education/survey': 62,
  'education/telescope': 62,
  'education/translation': 62,
  'education/typography': 62,
  'emoji/alien-29': 62,
  'emoji/angry-10': 62,
  'emoji/angry-44': 62,
  'emoji/big-eyes': 62,
  'emoji/big-smile': 62,
  'emoji/bigmouth': 62,
  'emoji/bleah': 60,
  'emoji/bomb': 62,
  'emoji/bored': 60,
  'emoji/broken-heart': 62,
  'emoji/bug': 62,
  'emoji/cake': 62,
  'emoji/cry-15': 62,
  'emoji/cry-57': 60,
  'emoji/cute': 62,
  'emoji/devil': 62,
  'emoji/disgusted': 60,
  'emoji/dizzy-face': 60,
  'emoji/fairy-wand': 62,
  'emoji/finger-snap': 60,
  'emoji/fist': 62,
  'emoji/ghost': 62,
  'emoji/happy-sun': 62,
  'emoji/heart': 63,
  'emoji/child': 60,
  'emoji/kid': 60,
  'emoji/kiss': 62,
  'emoji/laugh-17': 60,
  'emoji/laugh-35': 62,
  'emoji/lips': 62,
  'emoji/mad-12': 60,
  'emoji/mad-58': 60,
  'emoji/malicious': 60,
  'emoji/manga-62': 62,
  'emoji/manga-63': 62,
  'emoji/mask-face': 60,
  'emoji/monster': 62,
  'emoji/nerd': 60,
  'emoji/ninja': 60,
  'emoji/no-words': 60,
  'emoji/parrot': 60,
  'emoji/party': 60,
  'emoji/penguin': 60,
  'emoji/pirate': 60,
  'emoji/poop': 62,
  'emoji/puzzled': 62,
  'emoji/quite-happy': 62,
  'emoji/robot': 62,
  'emoji/rock': 60,
  'emoji/sad': 62,
  'emoji/satisfied': 62,
  'emoji/shark': 62,
  'emoji/shy': 62,
  'emoji/sick': 60,
  'emoji/silly': 60,
  'emoji/skull': 62,
  'emoji/sleep': 60,
  'emoji/sleep-2': 60,
  'emoji/sloth': 60,
  'emoji/smart': 60,
  'emoji/smile': 63,
  'emoji/smiling-face-glasses': 62,
  'emoji/smiling-face-sunglasses': 62,
  'emoji/soldier': 60,
  'emoji/speechless': 62,
  'emoji/spiteful': 60,
  'emoji/sunglasses-48': 62,
  'emoji/surprise': 62,
  'emoji/thumb-down': 62,
  'emoji/thumb-up': 62,
  'emoji/upset-13': 60,
  'emoji/upset-14': 60,
  'emoji/what': 62,
  'emoji/whiskers': 60,
  'emoji/wink-06': 60,
  'emoji/wink-11': 60,
  'emoji/wink-69': 60,
  'energy/battery': 62,
  'energy/battery-charging': 62,
  'energy/battery-level': 63,
  'energy/battery-low': 62,
  'energy/battery-power': 63,
  'energy/battery-status': 62,
  'energy/botany': 62,
  'energy/bulb': 62,
  'energy/bulb-saver': 62,
  'energy/car': 62,
  'energy/clover': 63,
  'energy/drop': 63,
  'energy/eco-home': 62,
  'energy/ecology': 62,
  'energy/factory': 62,
  'energy/forest': 60,
  'energy/fuel': 62,
  'energy/fuel-2': 62,
  'energy/fuel-electric': 62,
  'energy/globe': 62,
  'energy/humidity-52': 62,
  'energy/hybrid-car': 62,
  'energy/leaf': 62,
  'energy/light-switch': 63,
  'energy/money-growth': 60,
  'energy/oil': 62,
  'energy/panel': 62,
  'energy/plant-leaf': 63,
  'energy/plant-soil': 62,
  'energy/plant-vase': 62,
  'energy/plug': 63,
  'energy/plug-2': 62,
  'energy/power-level': 62,
  'energy/progress': 62,
  'energy/radiation': 62,
  'energy/recycling': 62,
  'energy/refresh': 63,
  'energy/reload': 63,
  'energy/save-planet': 62,
  'energy/shower': 62,
  'energy/sink-faucet': 62,
  'energy/sun': 63,
  'energy/temperature': 62,
  'energy/temperature-2': 62,
  'energy/tree-01': 62,
  'energy/waste': 62,
  'energy/waste-danger': 62,
  'energy/waste-recycling': 62,
  'energy/water': 62,
  'energy/water-hand': 62,
  'energy/water-sink': 62,
  'energy/wind': 62,
  'energy/windmill': 62,
  'energy/windmill-2': 62,
  'energy/world': 62,
  'files-folders/backup': 62,
  'files-folders/browse': 63,
  'files-folders/clear-data': 62,
  'files-folders/compressed-file': 60,
  'files-folders/document': 63,
  'files-folders/document-2': 62,
  'files-folders/document-copy': 62,
  'files-folders/file': 63,
  'files-folders/file-2': 62,
  'files-folders/file-add': 63,
  'files-folders/file-article': 63,
  'files-folders/file-audio': 60,
  'files-folders/file-copies': 62,
  'files-folders/file-copy': 63,
  'files-folders/file-delete': 63,
  'files-folders/file-export': 60,
  'files-folders/file-favorite': 60,
  'files-folders/file-font': 56,
  'files-folders/file-gallery': 60,
  'files-folders/file-gif': 56,
  'files-folders/file-gpx': 56,
  'files-folders/file-gzip': 56,
  'files-folders/file-history': 60,
  'files-folders/file-html': 56,
  'files-folders/file-ics': 56,
  'files-folders/file-image': 60,
  'files-folders/file-info': 60,
  'files-folders/file-iso': 56,
  'files-folders/file-jar': 56,
  'files-folders/file-java': 56,
  'files-folders/file-jpg': 56,
  'files-folders/file-js': 56,
  'files-folders/file-json': 56,
  'files-folders/file-jsp': 56,
  'files-folders/file-link': 60,
  'files-folders/file-locked': 60,
  'files-folders/file-log': 56,
  'files-folders/file-max': 56,
  'files-folders/file-md': 56,
  'files-folders/file-mkv': 56,
  'files-folders/file-money': 60,
  'files-folders/file-mov': 56,
  'files-folders/file-mp3': 56,
  'files-folders/file-mp4': 56,
  'files-folders/file-mpg': 56,
  'files-folders/file-no-access': 60,
  'files-folders/file-obj': 56,
  'files-folders/file-otf': 56,
  'files-folders/file-pdf': 56,
  'files-folders/file-php': 56,
  'files-folders/file-play': 60,
  'files-folders/file-png': 56,
  'files-folders/file-pptx': 56,
  'files-folders/file-preferences': 60,
  'files-folders/file-psd': 56,
  'files-folders/file-py': 56,
  'files-folders/file-question': 60,
  'files-folders/file-rar': 56,
  'files-folders/file-raw': 56,
  'files-folders/file-remove': 62,
  'files-folders/file-replace': 60,
  'files-folders/file-rss': 56,
  'files-folders/file-rtf': 56,
  'files-folders/file-ruby': 56,
  'files-folders/file-search': 60,
  'files-folders/file-settings': 60,
  'files-folders/file-shared': 60,
  'files-folders/file-sketch': 56,
  'files-folders/file-sql': 56,
  'files-folders/file-srt': 56,
  'files-folders/file-starred': 60,
  'files-folders/file-svg': 56,
  'files-folders/file-sync': 60,
  'files-folders/file-text': 63,
  'files-folders/file-tif': 56,
  'files-folders/file-tiff': 56,
  'files-folders/file-ttf': 56,
  'files-folders/file-txt': 56,
  'files-folders/file-user': 60,
  'files-folders/file-vector': 60,
  'files-folders/file-vvt': 56,
  'files-folders/file-wav': 56,
  'files-folders/file-xlsx': 56,
  'files-folders/file-xml': 56,
  'files-folders/file-zip': 56,
  'files-folders/folder-replace': 60,
  'files-folders/folder-upload': 60,
  'files-folders/folder-user': 60,
  'files-folders/folder-vector': 60,
  'files-folders/layers': 62,
  'files-folders/news': 62,
  'files-folders/note': 63,
  'files-folders/notebook': 62,
  'files-folders/paper': 62,
  'files-folders/raw-image': 60,
  'files-folders/research': 62,
  'files-folders/save-for-later': 62,
  'files-folders/saved-items': 63,
  'files-folders/upload-file': 63,
  'files-folders/zipped-file': 60,
  'multimedia/3d-glasses': 63,
  'multimedia/adult-content': 60,
  'multimedia/ai-generated-img': 62,
  'multimedia/album': 47,
  'multimedia/alpha-order': 62,
  'multimedia/antenna': 62,
  'multimedia/anti-shake': 60,
  'multimedia/aperture': 46,
  'multimedia/audio-description': 62,
  'multimedia/audio-jack': 62,
  'multimedia/audio-mixer': 60,
  'multimedia/auto-flash': 44,
  'multimedia/auto-flash-2': 44,
  'multimedia/auto-focus': 46,
  'multimedia/brightness': 46,
  'multimedia/browse': 63,
  'multimedia/btn-play': 44,
  'multimedia/btn-play-1': 44,
  'multimedia/btn-stop': 44,
  'multimedia/button-eject': 46,
  'multimedia/button-next': 46,
  'multimedia/button-pause': 47,
  'multimedia/button-play': 47,
  'multimedia/button-power': 47,
  'multimedia/button-previous': 46,
  'multimedia/button-record': 47,
  'multimedia/button-rewind': 46,
  'multimedia/button-skip': 46,
  'multimedia/button-stop': 47,
  'multimedia/camcorder': 62,
  'multimedia/camera': 47,
  'multimedia/camera-2': 46,
  'multimedia/camera-3': 46,
  'multimedia/camera-flash': 46,
  'multimedia/camera-flashlight': 46,
  'multimedia/camera-focus': 46,
  'multimedia/camera-focus-2': 47,
  'multimedia/camera-lens': 46,
  'multimedia/camera-roll': 62,
  'multimedia/camera-screen': 44,
  'multimedia/camera-shooting': 46,
  'multimedia/camera-timer': 46,
  'multimedia/clapperboard': 44,
  'multimedia/clapperboard-2': 44,
  'multimedia/clarinet': 60,
  'multimedia/compact-camera': 47,
  'multimedia/countdown': 44,
  'multimedia/countdown-2': 47,
  'multimedia/crop': 46,
  'multimedia/cycle': 47,
  'multimedia/digital-image': 62,
  'multimedia/digital-piano': 60,
  'multimedia/drums': 60,
  'multimedia/earbuds': 62,
  'multimedia/edit-color': 47,
  'multimedia/edit-contrast': 47,
  'multimedia/edit-curves': 62,
  'multimedia/edit-levels': 62,
  'multimedia/edit-saturation': 47,
  'multimedia/event-ticket': 62,
  'multimedia/expand': 63,
  'multimedia/face-recognition': 62,
  'multimedia/file-aac': 40,
  'multimedia/file-audio': 44,
  'multimedia/file-avi': 40,
  'multimedia/file-bmp': 40,
  'multimedia/file-epub': 40,
  'multimedia/file-flash': 40,
  'multimedia/file-flv': 40,
  'multimedia/file-mkv': 40,
  'multimedia/file-mov': 40,
  'multimedia/file-mp3': 40,
  'multimedia/file-mp4': 40,
  'multimedia/file-mpg': 40,
  'multimedia/file-vvt': 56,
  'multimedia/file-wav': 56,
  'multimedia/film': 62,
  'multimedia/flash-off': 44,
  'multimedia/flash-off-2': 44,
  'multimedia/folder-image': 44,
  'multimedia/folder-music': 44,
  'multimedia/frame-effect': 62,
  'multimedia/full-screen': 63,
  'multimedia/fullscreen': 47,
  'multimedia/grain-effect': 62,
  'multimedia/grid': 47,
  'multimedia/guitar': 44,
  'multimedia/headphones': 46,
  'multimedia/headphones-2': 46,
  'multimedia/headphones-3': 47,
  'multimedia/headphones-mic': 46,
  'multimedia/image': 47,
  'multimedia/image-add': 46,
  'multimedia/image-delete': 46,
  'multimedia/image-location': 44,
  'multimedia/img': 47,
  'multimedia/img-rotate-left': 60,
  'multimedia/img-rotate-right': 60,
  'multimedia/img-stack': 62,
  'multimedia/instant-camera': 44,
  'multimedia/instant-camera-2': 46,
  'multimedia/interview': 60,
  'multimedia/kid-2': 44,
  'multimedia/knob': 47,
  'multimedia/layers-2': 47,
  'multimedia/lightning': 47,
  'multimedia/loudspeaker': 63,
  'multimedia/love-movie': 62,
  'multimedia/macro': 46,
  'multimedia/media-player': 46,
  'multimedia/media-stream': 60,
  'multimedia/mic': 46,
  'multimedia/mic-2': 47,
  'multimedia/microphone': 47,
  'multimedia/microphone-2': 46,
  'multimedia/microphone-off': 62,
  'multimedia/movie': 62,
  'multimedia/movie-2': 46,
  'multimedia/movie-3': 46,
  'multimedia/movie-reel': 62,
  'multimedia/music': 47,
  'multimedia/music-album': 47,
  'multimedia/music-cloud': 44,
  'multimedia/music-note': 46,
  'multimedia/music-playlist': 62,
  'multimedia/night': 47,
  'multimedia/no-photo': 46,
  'multimedia/offline': 62,
  'multimedia/options': 63,
  'multimedia/pc-play-media': 62,
  'multimedia/phone-camera-back': 62,
  'multimedia/phone-music': 62,
  'multimedia/photo': 47,
  'multimedia/photo-album': 46,
  'multimedia/photo-frame': 46,
  'multimedia/photo-not-allowed': 44,
  'multimedia/piano': 44,
  'multimedia/piano-2': 60,
  'multimedia/picture': 47,
  'multimedia/play-media': 46,
  'multimedia/play-movie': 46,
  'multimedia/player': 63,
  'multimedia/playlist': 47,
  'multimedia/podcast': 62,
  'multimedia/podcast-mic': 62,
  'multimedia/polaroid': 62,
  'multimedia/polaroid-photo': 46,
  'multimedia/polaroid-portrait': 60,
  'multimedia/polaroid-shot-delete': 62,
  'multimedia/polaroid-shot-new': 62,
  'multimedia/polaroid-shots': 62,
  'multimedia/progress-indicator': 63,
  'multimedia/projector': 60,
  'multimedia/radio': 63,
  'multimedia/random': 62,
  'multimedia/raw-image': 60,
  'multimedia/record-player': 62,
  'multimedia/rotate-camera': 62,
  'multimedia/rotate-left': 60,
  'multimedia/rotate-right': 60,
  'multimedia/save-to-list': 63,
  'multimedia/saxophone': 60,
  'multimedia/scale-2': 62,
  'multimedia/screen-reader': 60,
  'multimedia/screen-sharing-2': 62,
  'multimedia/screen-sharing-off-2': 62,
  'multimedia/screen-touch': 62,
  'multimedia/sd-card': 63,
  'multimedia/selfie': 60,
  'multimedia/selfie-2': 60,
  'multimedia/sharpen': 47,
  'multimedia/sound': 63,
  'multimedia/sound-wave': 63,
  'multimedia/soundwave': 63,
  'multimedia/sparks': 63,
  'multimedia/speaker': 60,
  'multimedia/speaker-2': 62,
  'multimedia/sport-mode': 60,
  'multimedia/sticker': 62,
  'multimedia/subtitles': 62,
  'multimedia/sun': 47,
  'multimedia/tape': 62,
  'multimedia/temperature': 62,
  'multimedia/ticket': 63,
  'multimedia/tool-blur': 62,
  'multimedia/tripod': 62,
  'multimedia/trumpet': 60,
  'multimedia/vibrance': 63,
  'multimedia/video': 63,
  'multimedia/video-camera': 62,
  'multimedia/video-gallery': 62,
  'multimedia/video-gallery-2': 62,
  'multimedia/video-off': 62,
  'multimedia/video-player': 47,
  'multimedia/video-playlist': 62,
  'multimedia/vignette': 47,
  'multimedia/violin': 60,
  'multimedia/volume': 60,
  'multimedia/volume-2': 63,
  'multimedia/volume-down': 62,
  'multimedia/volume-mute': 60,
  'multimedia/volume-off': 60,
  'multimedia/volume-up': 62,
  'multimedia/white-balance': 47,
  'shopping/a-chart': 63,
  'shopping/add-to-cart': 62,
  'shopping/add-to-cart-2': 62,
  'shopping/award': 62,
  'shopping/bag-16': 62,
  'shopping/bag-17': 62,
  'shopping/bag-20': 62,
  'shopping/bag-add-18': 62,
  'shopping/bag-add-21': 62,
  'shopping/bag-delivery': 62,
  'shopping/bag-edit': 62,
  'shopping/bag-remove-19': 62,
  'shopping/bag-remove-22': 62,
  'shopping/bag-time': 62,
  'shopping/barcode': 62,
  'shopping/barcode-qr': 62,
  'shopping/barcode-scan': 60,
  'shopping/basket': 63,
  'shopping/basket-add': 60,
  'shopping/basket-edit': 60,
  'shopping/basket-favorite': 60,
  'shopping/basket-remove': 60,
  'shopping/basket-search': 60,
  'shopping/basket-share': 60,
  'shopping/basket-simple': 62,
  'shopping/basket-simple-add': 62,
  'shopping/basket-simple-remove': 62,
  'shopping/basket-update': 60,
  'shopping/bill': 62,
  'shopping/billboard': 62,
  'shopping/bitcoin': 62,
  'shopping/board': 60,
  'shopping/box': 63,
  'shopping/box-2': 62,
  'shopping/box-3d-50': 60,
  'shopping/box-3d-67': 56,
  'shopping/box-ribbon': 62,
  'shopping/businessman-04': 62,
  'shopping/card-edit': 62,
  'shopping/card-favorite': 62,
  'shopping/card-remove': 62,
  'shopping/card-update': 60,
  'shopping/cart': 63,
  'shopping/cart-add': 60,
  'shopping/cart-add-9': 60,
  'shopping/cart-favorite': 62,
  'shopping/cart-full': 60,
  'shopping/cart-refresh': 60,
  'shopping/cart-remove': 60,
  'shopping/cart-remove-9': 60,
  'shopping/cart-return': 62,
  'shopping/cart-simple-add': 62,
  'shopping/cart-simple-remove': 62,
  'shopping/cart-speed': 62,
  'shopping/cash-register': 62,
  'shopping/contactless-card': 60,
  'shopping/coupon': 62,
  'shopping/credit-card': 62,
  'shopping/credit-card-in': 62,
  'shopping/credit-locked': 60,
  'shopping/currency-dollar': 62,
  'shopping/currency-euro': 62,
  'shopping/currency-exchange': 62,
  'shopping/currency-exchange-2': 60,
  'shopping/currency-pound': 62,
  'shopping/currency-yen': 62,
  'shopping/customer-support': 62,
  'shopping/cut': 60,
  'shopping/delivery': 60,
  'shopping/delivery-2': 62,
  'shopping/delivery-3': 62,
  'shopping/delivery-fast': 62,
  'shopping/delivery-time': 60,
  'shopping/delivery-track': 60,
  'shopping/discount-2': 62,
  'shopping/farmer-market': 62,
  'shopping/hand-card': 60,
  'shopping/cheque': 62,
  'shopping/cheque-2': 62,
  'shopping/cheque-3': 62,
  'shopping/label': 60,
  'shopping/lifering': 63,
  'shopping/list': 62,
  'shopping/market-music': 62,
  'shopping/market-play': 62,
  'shopping/mobile-banking': 60,
  'shopping/mobile-card': 60,
  'shopping/mobile-cart': 56,
  'shopping/mobile-touch': 56,
  'shopping/money-transfer': 60,
  'shopping/new': 60,
  'shopping/newsletter': 62,
  'shopping/online-banking': 60,
  'shopping/pallet': 62,
  'shopping/pallet-stacked-boxes': 62,
  'shopping/payment-method': 62,
  'shopping/percent-sign': 63,
  'shopping/percentage-38': 60,
  'shopping/personal-trainer': 62,
  'shopping/pos': 60,
  'shopping/present': 63,
  'shopping/receipt': 62,
  'shopping/receipt-list-42': 62,
  'shopping/receipt-list-43': 62,
  'shopping/refund': 60,
  'shopping/round-dollar': 60,
  'shopping/round-euro': 60,
  'shopping/round-pound': 60,
  'shopping/round-yen': 60,
  'shopping/sale': 60,
  'shopping/scale-4': 62,
  'shopping/shipping-container': 62,
  'shopping/shop': 63,
  'shopping/shop-location': 60,
  'shopping/shopping-bag': 63,
  'shopping/shopping-cart': 63,
  'shopping/shopping-cart-2': 62,
  'shopping/shopping-label': 63,
  'shopping/shopping-tag': 62,
  'shopping/sign-24h': 56,
  'shopping/sign-board': 62,
  'shopping/sign-closed': 56,
  'shopping/sign-open': 56,
  'shopping/size-large': 62,
  'shopping/size-medium': 62,
  'shopping/size-small': 62,
  'shopping/stock-2': 62,
  'shopping/stock-market': 62,
  'shopping/storage-unit': 62,
  'shopping/store': 62,
  'shopping/support': 63,
  'shopping/tag': 63,
  'shopping/tag-add': 62,
  'shopping/tag-cut': 62,
  'shopping/tag-check': 62,
  'shopping/tag-loyalty': 62,
  'shopping/tag-remove': 62,
  'shopping/tag-sale': 60,
  'shopping/tags-stack': 62,
  'shopping/track-delivery': 60,
  'shopping/virtual-assistant-2': 60,
  'shopping/wallet': 62,
  'shopping/wallet-43': 62,
  'shopping/wallet-44': 62,
  'technology/3d-printing': 60,
  'technology/ai': 62,
  'technology/ai-generated-img': 62,
  'technology/algorithm': 62,
  'technology/android': 62,
  'technology/antenna': 62,
  'technology/api': 60,
  'technology/app-services': 60,
  'technology/apple': 62,
  'technology/artificial-brain': 60,
  'technology/artificial-intelligence': 60,
  'technology/audio-jack': 62,
  'technology/augmented-reality': 62,
  'technology/automated-logistics': 62,
  'technology/baby-monitor': 62,
  'technology/battery-level': 63,
  'technology/binary-code': 62,
  'technology/block': 63,
  'technology/blockchain': 62,
  'technology/cable': 62,
  'technology/cctv': 62,
  'technology/cd-reader': 62,
  'technology/cloud-mining': 62,
  'technology/computer': 63,
  'technology/computer-monitor': 62,
  'technology/connection': 62,
  'technology/contactless': 63,
  'technology/content-360deg': 62,
  'technology/content-delivery': 62,
  'technology/control-panel': 63,
  'technology/controller': 62,
  'technology/controller-2': 62,
  'technology/cpu': 60,
  'technology/cryptography': 62,
  'technology/cyborg': 62,
  'technology/decentralize': 62,
  'technology/decision-process': 60,
  'technology/device-connection': 62,
  'technology/digital-image': 62,
  'technology/digital-key': 62,
  'technology/disk': 63,
  'technology/disk-reader': 62,
  'technology/drone': 60,
  'technology/drone-2': 60,
  'technology/e-reader': 62,
  'technology/earbuds': 62,
  'technology/electronic-circuit': 62,
  'technology/engine-start': 62,
  'technology/eye-recognition': 62,
  'technology/face-recognition': 62,
  'technology/firewall': 62,
  'technology/gaming-console': 62,
  'technology/gaming-controller': 63,
  'technology/gopro': 56,
  'technology/graphics-tablet': 62,
  'technology/hacker': 60,
  'technology/hair-clipper': 62,
  'technology/handheld-console': 60,
  'technology/hdmi': 62,
  'technology/headphones': 62,
  'technology/headphones-2': 62,
  'technology/headphones-3': 63,
  'technology/headset': 60,
  'technology/humanoid': 62,
  'technology/hybrid-car': 62,
  'technology/charger-cable': 60,
  'technology/chat-bot': 62,
  'technology/keyboard': 62,
  'technology/keyboard-hide': 62,
  'technology/keyboard-mouse': 60,
  'technology/keyboard-wired': 62,
  'technology/keyboard-wireless': 62,
  'technology/l-add': 62,
  'technology/l-check': 62,
  'technology/l-location': 60,
  'technology/l-remove': 62,
  'technology/l-search': 60,
  'technology/l-security': 60,
  'technology/l-settings': 60,
  'technology/l-sync': 60,
  'technology/l-system-update': 62,
  'technology/landscape-orientation': 63,
  'technology/laptop': 62,
  'technology/laptop-1': 63,
  'technology/laptop-2': 63,
  'technology/license-key': 60,
  'technology/live-streaming': 60,
  'technology/lock-landscape': 62,
  'technology/lock-orientation': 60,
  'technology/lock-portrait': 62,
  'technology/logic': 60,
  'technology/machine-learning': 62,
  'technology/media-player': 62,
  'technology/messaging': 60,
  'technology/metrics': 63,
  'technology/mic': 62,
  'technology/mic-2': 63,
  'technology/migration': 60,
  'technology/mobile-banking': 60,
  'technology/mobile-chat': 62,
  'technology/mobile-phone': 63,
  'technology/mouse': 63,
  'technology/mouse-2': 62,
  'technology/music-player': 62,
  'technology/navigation': 62,
  'technology/nodes': 62,
  'technology/offline': 62,
  'technology/online-banking': 60,
  'technology/open-ai': 62,
  'technology/p-add': 62,
  'technology/p-edit': 62,
  'technology/p-heart': 62,
  'technology/p-check': 62,
  'technology/p-location': 60,
  'technology/p-remove': 62,
  'technology/p-search': 60,
  'technology/p-settings': 60,
  'technology/p-share': 60,
  'technology/p-sync': 60,
  'technology/p-system-update': 62,
  'technology/p-time': 60,
  'technology/parking-sensors': 62,
  'technology/pattern-recognition': 62,
  'technology/pc': 62,
  'technology/pc-monitor': 63,
  'technology/pc-mouse': 62,
  'technology/pc-play-media': 62,
  'technology/pci-card': 62,
  'technology/phone-button': 62,
  'technology/phone-camera-back': 62,
  'technology/phone-camera-front': 62,
  'technology/phone-dock': 62,
  'technology/phone-charging': 62,
  'technology/phone-charging-2': 62,
  'technology/phone-charging-3': 62,
  'technology/phone-toolbar': 63,
  'technology/plug': 63,
  'technology/plug-2': 62,
  'technology/print': 63,
  'technology/printer': 62,
  'technology/printer-p': 56,
  'technology/printer-p-2': 56,
  'technology/projector': 60,
  'technology/ram': 62,
  'technology/ram-2': 62,
  'technology/reading-tablet': 62,
  'technology/redmine': 63,
  'technology/remote-control': 62,
  'technology/robot-cleaner': 62,
  'technology/robotic-arm': 62,
  'technology/router': 62,
  'technology/satellite': 62,
  'technology/satellite-dish': 62,
  'technology/screen-reader': 60,
  'technology/screen-rotation': 62,
  'technology/screen-sharing-2': 62,
  'technology/screen-sharing-off-2': 62,
  'technology/send-to-phone': 62,
  'technology/sensor': 63,
  'technology/server': 62,
  'technology/server-rack': 63,
  'technology/signal': 62,
  'technology/sim-card': 63,
  'technology/smart-house': 60,
  'technology/smartphone': 63,
  'technology/smartwatch': 63,
  'technology/socket': 62,
  'technology/socket-europe-1': 62,
  'technology/socket-europe-2': 62,
  'technology/socket-uk': 62,
  'technology/sparks': 63,
  'technology/ssd': 62,
  'technology/sync-devices': 62,
  'technology/system-update': 63,
  'technology/tablet': 63,
  'technology/tablet-2': 62,
  'technology/tablet-charging': 62,
  'technology/tablet-toolbar': 63,
  'technology/three-dimensional-object': 63,
  'technology/three-dimensional-world': 60,
  'technology/traffic': 63,
  'technology/transactions': 63,
  'technology/translation': 62,
  'technology/tv': 63,
  'technology/tv-stand': 62,
  'technology/usb': 62,
  'technology/video-off': 62,
  'technology/video-player': 63,
  'technology/vintage-computer': 62,
  'technology/vintage-tv': 62,
  'technology/virtual-assistant': 62,
  'technology/virtual-assistant-2': 60,
  'technology/virtual-environment': 62,
  'technology/virtual-reality': 60,
  'technology/voice-recognition': 63,
  'technology/vpn': 62,
  'technology/vr-controller': 62,
  'technology/vr-headset': 62,
  'technology/watch': 62,
  'technology/watch-2': 62,
  'technology/webcam': 62,
  'technology/webcam-2': 62,
  'technology/wifi': 63,
  'technology/wifi-2': 60,
  'technology/wifi-off': 62,
  'technology/wifi-protected': 62,
  'technology/wifi-router': 62,
  'technology/wireless-charging': 62,
  'transportation/air-baloon': 62,
  'transportation/airbag': 62,
  'transportation/airplane': 62,
  'transportation/alien-33': 62,
  'transportation/anchor': 62,
  'transportation/baby-car-seat': 62,
  'transportation/battery-level': 63,
  'transportation/bike': 62,
  'transportation/bike-bmx': 62,
  'transportation/boat': 62,
  'transportation/boat-front': 60,
  'transportation/boat-small-02': 62,
  'transportation/boat-small-03': 62,
  'transportation/brakes': 62,
  'transportation/bus': 60,
  'transportation/bus-front-10': 62,
  'transportation/bus-front-12': 62,
  'transportation/car': 62,
  'transportation/car-2': 62,
  'transportation/car-accident': 62,
  'transportation/car-connect': 62,
  'transportation/car-door': 62,
  'transportation/car-front': 63,
  'transportation/car-lights': 62,
  'transportation/car-parking': 62,
  'transportation/car-simple': 60,
  'transportation/car-sport': 60,
  'transportation/car-ventilation': 62,
  'transportation/car-wash': 62,
  'transportation/cone': 62,
  'transportation/control-panel': 63,
  'transportation/cycling': 62,
  'transportation/dashboard': 63,
  'transportation/delivery': 60,
  'transportation/drone': 60,
  'transportation/drone-2': 60,
  'transportation/engine': 62,
  'transportation/engine-start': 62,
  'transportation/flight': 60,
  'transportation/flip-up': 62,
  'transportation/fuel': 62,
  'transportation/fuel-2': 62,
  'transportation/fuel-electric': 62,
  'transportation/helicopter': 62,
  'transportation/helmet': 62,
  'transportation/hybrid-car': 62,
  'transportation/landing': 60,
  'transportation/light-traffic': 62,
  'transportation/love-car': 60,
  'transportation/moto': 62,
  'transportation/oil': 62,
  'transportation/parking': 62,
  'transportation/parking-sensors': 62,
  'transportation/plane': 62,
  'transportation/power-level': 60,
  'transportation/racing-bike': 56,
  'transportation/rim': 62,
  'transportation/road': 60,
  'transportation/road-2': 62,
  'transportation/scooter': 62,
  'transportation/seat': 62,
  'transportation/seatbelt': 62,
  'transportation/sensor': 63,
  'transportation/shuttle': 62,
  'transportation/skateboard': 62,
  'transportation/skateboard-2': 62,
  'transportation/speedometer': 63,
  'transportation/steering-wheel': 62,
  'transportation/stop-sign': 62,
  'transportation/submarine': 60,
  'transportation/take-off': 60,
  'transportation/taxi': 62,
  'transportation/tractor': 62,
  'transportation/train': 62,
  'transportation/train-speed': 60,
  'transportation/tram': 62,
  'transportation/truck-front': 62,
  'transportation/trunk': 62,
  'transportation/ventilation': 62,
  'transportation/vespa': 60,
  'transportation/vespa-front': 62,
  'transportation/walk': 62,
  'transportation/washing-fluid': 62,
  'transportation/wheel': 62,
  'transportation/wheel-2': 62,
  'user-interface/a-chart': 63,
  'user-interface/a-chat': 62,
  'user-interface/a-tag': 63,
  'user-interface/a-tag-add': 62,
  'user-interface/a-tag-remove': 62,
  'user-interface/access-key': 63,
  'user-interface/add': 62,
  'user-interface/add-fav': 62,
  'user-interface/add-favorite': 62,
  'user-interface/add-like': 62,
  'user-interface/add-notification': 62,
  'user-interface/add-to-cart': 62,
  'user-interface/add-to-cart-2': 62,
  'user-interface/alarm': 63,
  'user-interface/alarm-add': 62,
  'user-interface/alarm-disable': 62,
  'user-interface/analytics': 63,
  'user-interface/app-store': 62,
  'user-interface/apps': 63,
  'user-interface/archive': 63,
  'user-interface/archive-drawer': 63,
  'user-interface/at-sign': 63,
  'user-interface/attach': 63,
  'user-interface/attachment': 62,
  'user-interface/b-comment': 62,
  'user-interface/b-eye': 62,
  'user-interface/b-chart': 62,
  'user-interface/backward': 63,
  'user-interface/ban': 63,
  'user-interface/basket': 63,
  'user-interface/battery-charging': 62,
  'user-interface/battery-low': 62,
  'user-interface/battery-power': 63,
  'user-interface/battery-status': 62,
  'user-interface/bell': 62,
  'user-interface/bin': 63,
  'user-interface/blog': 63,
  'user-interface/bluetooth': 62,
  'user-interface/board-2': 60,
  'user-interface/bolt': 62,
  'user-interface/book': 63,
  'user-interface/bookmark': 63,
  'user-interface/bookmark-add': 62,
  'user-interface/bookmark-add-2': 62,
  'user-interface/bookmark-delete': 62,
  'user-interface/bookmark-delete-2': 62,
  'user-interface/bookmarks': 62,
  'user-interface/bullet-list': 63,
  'user-interface/buzz': 62,
  'user-interface/c-add': 63,
  'user-interface/c-delete': 63,
  'user-interface/c-edit': 63,
  'user-interface/c-check': 63,
  'user-interface/c-info': 62,
  'user-interface/c-pulse': 62,
  'user-interface/c-question': 62,
  'user-interface/c-remove': 63,
  'user-interface/c-warning': 62,
  'user-interface/calendar': 63,
  'user-interface/calendar-2': 62,
  'user-interface/calendar-date': 62,
  'user-interface/calendar-date-2': 62,
  'user-interface/calendar-day-view': 63,
  'user-interface/calendar-event': 62,
  'user-interface/calendar-event-2': 62,
  'user-interface/calendar-event-create': 62,
  'user-interface/clear-data': 62,
  'user-interface/clock': 63,
  'user-interface/cloud': 63,
  'user-interface/cloud-forecast': 62,
  'user-interface/cogwheel': 63,
  'user-interface/comment': 63,
  'user-interface/comment-add': 62,
  'user-interface/comments': 62,
  'user-interface/compare-items': 63,
  'user-interface/components': 62,
  'user-interface/configuration': 40,
  'user-interface/configuration-tool': 40,
  'user-interface/configuration-tools': 62,
  'user-interface/control-panel': 63,
  'user-interface/d-add': 62,
  'user-interface/d-delete': 62,
  'user-interface/d-edit': 62,
  'user-interface/d-chart': 63,
  'user-interface/d-check': 62,
  'user-interface/d-remove': 62,
  'user-interface/dashboard': 63,
  'user-interface/data-download': 63,
  'user-interface/data-settings': 60,
  'user-interface/data-upload': 63,
  'user-interface/database': 63,
  'user-interface/delete': 62,
  'user-interface/delete-forever': 62,
  'user-interface/design-system': 63,
  'user-interface/disk': 63,
  'user-interface/dock-bottom': 63,
  'user-interface/dock-left': 63,
  'user-interface/dock-right': 63,
  'user-interface/dock-top': 63,
  'user-interface/download': 63,
  'user-interface/drop': 63,
  'user-interface/e-add': 63,
  'user-interface/e-delete': 63,
  'user-interface/e-remove': 63,
  'user-interface/edit': 62,
  'user-interface/edit-note': 62,
  'user-interface/email': 63,
  'user-interface/email-open': 29,
  'user-interface/empty': 63,
  'user-interface/enlarge': 63,
  'user-interface/event-confirm': 62,
  'user-interface/event-create': 62,
  'user-interface/exclamation-mark': 63,
  'user-interface/eye': 62,
  'user-interface/f-add': 62,
  'user-interface/f-comment': 62,
  'user-interface/f-dashboard': 62,
  'user-interface/f-delete': 62,
  'user-interface/f-chat': 62,
  'user-interface/f-check': 62,
  'user-interface/f-remove': 62,
  'user-interface/fav-list': 60,
  'user-interface/fav-remove': 62,
  'user-interface/favorite': 63,
  'user-interface/feedback': 62,
  'user-interface/file-add': 63,
  'user-interface/file-article': 63,
  'user-interface/file-delete': 63,
  'user-interface/file-text': 63,
  'user-interface/filter': 62,
  'user-interface/filter-check': 62,
  'user-interface/filter-remove': 62,
  'user-interface/filter-tool': 63,
  'user-interface/find-replace': 62,
  'user-interface/flame': 62,
  'user-interface/floors': 62,
  'user-interface/floppy-disk': 63,
  'user-interface/forward': 63,
  'user-interface/full-screen': 63,
  'user-interface/fullsize': 63,
  'user-interface/funnel': 62,
  'user-interface/g-chart': 63,
  'user-interface/g-check': 62,
  'user-interface/gallery-layout': 62,
  'user-interface/gallery-view': 63,
  'user-interface/gantt': 63,
  'user-interface/gear': 62,
  'user-interface/geometry': 62,
  'user-interface/grid-interface': 63,
  'user-interface/grid-layout': 62,
  'user-interface/grid-view': 62,
  'user-interface/heart': 63,
  'user-interface/hide': 62,
  'user-interface/home': 63,
  'user-interface/home-2': 62,
  'user-interface/home-3': 63,
  'user-interface/hot-key': 62,
  'user-interface/hotspot': 62,
  'user-interface/hourglass': 62,
  'user-interface/house': 63,
  'user-interface/hyperlink': 62,
  'user-interface/hyperlink-broken': 62,
  'user-interface/chain': 60,
  'user-interface/chart': 63,
  'user-interface/chat': 63,
  'user-interface/check': 63,
  'user-interface/check-all': 62,
  'user-interface/check-double': 62,
  'user-interface/check-in': 62,
  'user-interface/check-list': 62,
  'user-interface/check-out': 62,
  'user-interface/check-single': 63,
  'user-interface/checkbox-btn': 63,
  'user-interface/checkbox-btn-checked': 63,
  'user-interface/chemistry': 63,
  'user-interface/i-add': 62,
  'user-interface/i-delete': 62,
  'user-interface/i-edit': 63,
  'user-interface/i-check': 63,
  'user-interface/i-remove': 62,
  'user-interface/incognito': 62,
  'user-interface/increase': 63,
  'user-interface/infinite': 62,
  'user-interface/info': 63,
  'user-interface/key': 62,
  'user-interface/label': 60,
  'user-interface/layout': 62,
  'user-interface/layout-grid': 63,
  'user-interface/leaf': 62,
  'user-interface/leave': 62,
  'user-interface/letter': 63,
  'user-interface/lifering': 63,
  'user-interface/light-control': 63,
  'user-interface/like': 63,
  'user-interface/link': 63,
  'user-interface/lock': 63,
  'user-interface/log-out': 63,
  'user-interface/magnifier': 62,
  'user-interface/magnifier-zoom-in': 62,
  'user-interface/magnifier-zoom-out': 62,
  'user-interface/mail': 63,
  'user-interface/megaphone': 63,
  'user-interface/menu': 63,
  'user-interface/menu-2': 63,
  'user-interface/menu-3': 63,
  'user-interface/menu-4': 63,
  'user-interface/menu-6': 63,
  'user-interface/menu-7': 63,
  'user-interface/menu-8': 63,
  'user-interface/menu-dots': 63,
  'user-interface/metrics': 63,
  'user-interface/mirror-tablet-phone': 63,
  'user-interface/n-edit': 63,
  'user-interface/n-check': 63,
  'user-interface/network-communication': 62,
  'user-interface/network-connection': 63,
  'user-interface/networking': 62,
  'user-interface/new-notification': 63,
  'user-interface/news': 62,
  'user-interface/no-results': 62,
  'user-interface/note': 63,
  'user-interface/notification': 60,
  'user-interface/notification-2': 63,
  'user-interface/o-check': 62,
  'user-interface/o-warning': 62,
  'user-interface/offline': 62,
  'user-interface/opening-times': 62,
  'user-interface/options': 63,
  'user-interface/p-chart': 62,
  'user-interface/padlock': 62,
  'user-interface/padlock-unlocked': 62,
  'user-interface/paragraph': 63,
  'user-interface/password': 62,
  'user-interface/pen': 63,
  'user-interface/pen-2': 63,
  'user-interface/pencil': 62,
  'user-interface/phone': 62,
  'user-interface/phone-call': 62,
  'user-interface/phone-call-end': 62,
  'user-interface/plant-leaf': 63,
  'user-interface/playlist': 63,
  'user-interface/preferences': 63,
  'user-interface/present': 63,
  'user-interface/privacy': 62,
  'user-interface/privacy-settings': 62,
  'user-interface/progress-2': 62,
  'user-interface/progress-indicator': 63,
  'user-interface/question-mark': 63,
  'user-interface/questionnaire': 62,
  'user-interface/r-chat': 62,
  'user-interface/radio-btn': 63,
  'user-interface/radio-btn-checked': 63,
  'user-interface/remove': 62,
  'user-interface/remove-fav': 62,
  'user-interface/remove-favorite': 62,
  'user-interface/remove-like': 62,
  'user-interface/roadmap': 62,
  'user-interface/s-add': 63,
  'user-interface/s-ban': 60,
  'user-interface/s-delete': 63,
  'user-interface/s-edit': 62,
  'user-interface/s-check': 63,
  'user-interface/s-info': 62,
  'user-interface/s-pulse': 62,
  'user-interface/s-question': 62,
  'user-interface/s-remove': 63,
  'user-interface/s-warning': 62,
  'user-interface/save-for-later': 62,
  'user-interface/save-to-list': 63,
  'user-interface/saved-items': 63,
  'user-interface/screen-enlarge': 63,
  'user-interface/screen-expand': 60,
  'user-interface/screen-maximize': 62,
  'user-interface/screen-sharing-2': 62,
  'user-interface/screen-sharing-off-2': 62,
  'user-interface/search': 62,
  'user-interface/search-content': 62,
  'user-interface/search-zoom-in': 62,
  'user-interface/search-zoom-out': 62,
  'user-interface/security': 63,
  'user-interface/segmentation': 63,
  'user-interface/select': 63,
  'user-interface/send': 62,
  'user-interface/send-message': 63,
  'user-interface/settings': 60,
  'user-interface/settings-gear': 63,
  'user-interface/settings-wheel': 62,
  'user-interface/setup-options': 62,
  'user-interface/setup-preferences': 63,
  'user-interface/setup-tools': 62,
  'user-interface/share': 63,
  'user-interface/sharing': 63,
  'user-interface/shop': 63,
  'user-interface/shopping-bag': 63,
  'user-interface/shopping-cart': 63,
  'user-interface/shopping-cart-2': 62,
  'user-interface/shopping-label': 63,
  'user-interface/shopping-tag': 60,
  'user-interface/sidebar': 63,
  'user-interface/slide-left': 63,
  'user-interface/slide-right': 63,
  'user-interface/social-sharing': 63,
  'user-interface/sort-tool': 63,
  'user-interface/spaceship': 62,
  'user-interface/speedometer': 63,
  'user-interface/stack': 63,
  'user-interface/star': 63,
  'user-interface/star-rate': 63,
  'user-interface/stopwatch': 63,
  'user-interface/support': 63,
  'user-interface/survey': 62,
  'user-interface/switches': 62,
  'user-interface/system-configuration': 62,
  'user-interface/system-preferences': 63,
  'user-interface/t-add': 60,
  'user-interface/t-delete': 60,
  'user-interface/t-remove': 60,
  'user-interface/table-layout': 60,
  'user-interface/table-move': 62,
  'user-interface/table-slide': 62,
  'user-interface/tag': 63,
  'user-interface/tags-stack': 62,
  'user-interface/target': 62,
  'user-interface/telephone': 62,
  'user-interface/time-alarm': 62,
  'user-interface/time-clock': 62,
  'user-interface/time-machine': 60,
  'user-interface/timeline': 63,
  'user-interface/toggle': 63,
  'user-interface/translation': 62,
  'user-interface/trash': 62,
  'user-interface/trash-can': 62,
  'user-interface/unlink': 63,
  'user-interface/unlocked': 62,
  'user-interface/upload': 63,
  'user-interface/url': 62,
  'user-interface/verified': 62,
  'user-interface/video-gallery': 62,
  'user-interface/view': 63,
  'user-interface/virtual-assistant-2': 60,
  'user-interface/warning-sign': 62,
  'user-interface/web-hyperlink': 63,
  'user-interface/web-link': 62,
  'user-interface/web-url': 62,
  'user-interface/webpage': 63,
  'user-interface/widget': 63,
  'user-interface/window-add': 62,
  'user-interface/window-delete': 62,
  'user-interface/wireframe': 63,
  'user-interface/wrench': 60,
  'user-interface/wrench-tool': 62,
  'user-interface/zoom': 63,
  'user-interface/zoom-in': 62,
  'user-interface/zoom-out': 62,
  'users/accessibility': 62,
  'users/account': 63,
  'users/address-book': 60,
  'users/contact': 62,
  'users/contact-list': 62,
  'users/contacts': 62,
  'users/couple-gay': 60,
  'users/couple-lesbian': 60,
  'users/diaper-changing-area': 62,
  'users/doctor': 62,
  'users/exchange': 60,
  'users/face-man': 62,
  'users/face-woman': 60,
  'users/family': 60,
  'users/family-roof': 60,
  'users/farmer': 62,
  'users/female-figure': 62,
  'users/female-sign': 62,
  'users/file-shared': 60,
  'users/file-user': 60,
  'users/folder-shared': 60,
  'users/folder-user': 60,
  'users/gathering-restrictions': 60,
  'users/grandparent': 60,
  'users/hacker': 60,
  'users/hair-man': 62,
  'users/hair-woman': 62,
  'users/humanoid': 62,
  'users/child': 60,
  'users/info-point': 62,
  'users/interview': 60,
  'users/joint-account': 60,
  'users/male-sign': 62,
  'users/man': 62,
  'users/man-arrow-down': 60,
  'users/man-arrow-up': 60,
  'users/man-profile': 60,
  'users/meeting': 60,
  'users/mickey-mouse': 62,
  'users/miner': 62,
  'users/mobile-contact': 60,
  'users/negative-judgement': 60,
  'users/no-contact': 62,
  'users/office-badge': 62,
  'users/office-pass': 63,
  'users/parenting': 60,
  'users/payee': 62,
  'users/payor': 62,
  'users/people-network': 60,
  'users/police-officer': 62,
  'users/positive-judgement': 60,
  'users/pregnant-woman': 62,
  'users/privacy-policy': 62,
  'users/profile': 63,
  'users/property': 62,
  'users/reading': 60,
  'users/search-user': 60,
  'users/security-gate': 62,
  'users/security-officer': 60,
  'users/social-distancing': 60,
  'users/standing-man': 60,
  'users/standing-woman': 60,
  'users/stay-home': 60,
  'users/team': 62,
  'users/toilette': 60,
  'users/user': 63,
  'users/user-2': 62,
  'users/user-add': 62,
  'users/user-bubble': 62,
  'users/user-c-frame': 62,
  'users/user-c-frame-2': 62,
  'users/user-c-frame-3': 62,
  'users/user-create': 62,
  'users/user-delete': 62,
  'users/user-delete-cross': 60,
  'users/user-delete-line': 62,
  'users/user-edit': 62,
  'users/user-focus': 62,
  'users/user-group': 62,
  'users/user-heart': 62,
  'users/user-check': 62,
  'users/user-list': 62,
  'users/user-location': 60,
  'users/user-location-2': 60,
  'users/user-lock': 62,
  'users/user-new': 62,
  'users/user-remove': 62,
  'users/user-s-frame': 62,
  'users/user-s-frame-2': 62,
  'users/user-s-frame-3': 62,
  'users/user-search': 60,
  'users/user-share': 60,
  'users/user-star': 60,
  'users/user-sync': 60,
  'users/user-time': 60,
  'users/user-wearing-glasses': 60,
  'users/users': 62,
  'users/users-add': 60,
  'users/users-heart': 60,
  'users/users-check': 60,
  'users/users-location': 60,
  'users/users-lock': 60,
  'users/users-meeting': 60,
  'users/users-mm': 62,
  'users/users-remove': 60,
  'users/users-wm': 62,
  'users/users-ww': 62,
  'users/virtual-assistant-2': 60,
  'users/voice-record': 62,
  'users/wc-sign': 60,
  'users/wheelchair': 62,
  'users/woman': 60,
  'users/woman-arrow-down': 60,
  'users/woman-arrow-up': 60,
  'users/woman-man': 60,
  'users/woman-profile': 60,
  'users/work-badge': 62,
}
